<template>
  <div>
    <el-collapse v-model="activeNames" style="width: 100%">
      <controlWidthAndSizeAndZindex v-if="curNav === 0" :options="options" :ids="ids" />
      <template v-if="curNav === 0">
        <el-collapse-item title="导航" name="1">
          <div class="navBox mb8" @click="changeNav(1, true)">
            <span class="navTitle">一级导航</span>
            <span class="navLabel fs12">配置<i class="navIcon icon-portal-arrows-right"></i></span>
          </div>
          <div class="navBox" @click="changeNav(2, true)">
            <span class="navTitle">二级导航</span>
            <span class="navLabel fs12">配置<i class="navIcon icon-portal-arrows-right"></i></span>
          </div>
        </el-collapse-item>
        <el-collapse-item title="排列" name="2">
          <div class="verticallyCenter mb16">
            <span class="mr16 fs14">方向</span>
            <div class="autoLayout-directions">
              <el-tooltip class="item" effect="dark" content="纵向排列" placement="top-end" :open-delay="1000">
                <span @click="showVerticalType = true" :class="showVerticalType? 'active' : ''"
                      class="icon-portal-direction-down"></span>
              </el-tooltip>
              <el-tooltip class="item" effect="dark" content="横向排列" placement="top-end" :open-delay="1000">
                <span @click="showVerticalType = false" :class="!showVerticalType ? 'active' : ''"
                      class="icon-portal-direction-right"></span>
              </el-tooltip>
            </div>
          </div>
<!--          <cx-slider label="方向" :value.sync="showVerticalType" :options="alignmentTypeOptions" :showToolTip="true" />-->
          <cx-slider label="对齐" :value.sync="alignmentType" :options="alignmentTypeOptions" :showToolTip="true" />
          <div class="content-item mt12" style="display: none">
            <el-checkbox v-model="isWrap">允许换行</el-checkbox>
            <div class="verticallyCenter mt12" v-if="isWrap">
              <span class="fs14 mr16">下间距</span>
              <div style="width: calc(100% - 70px)">
                <slider-and-input
                  inputWidth="small"
                  inputHeight="small"
                  :value.sync="navMarginBottom"
                  title=""
                  titlePosition="singleLine"
                  :sliderMax="100"
                  suffix="px"
                />
              </div>
            </div>
          </div>
          <div v-if="!loginType" class="verticallyCenter mt16">
            <span class="fs14 mr16">间距</span>
            <div style="width: calc(100% - 44px)">
              <slider-and-input
                inputWidth="small"
                inputHeight="small"
                :value.sync="navMargin"
                title=""
                titlePosition="singleLine"
                :sliderMax="100"
                suffix="px"
              />
            </div>
          </div>
        </el-collapse-item>
        <el-collapse-item title="背景" name="3">
          <cx-background infoTips="支持上传图片" :background.sync="background" imgType="10" />
        </el-collapse-item>
        <el-collapse-item title="边框" name="4">
          <div class="setting-item">
            <div class="content">
              <div>
                <div class="content-item verticallyCenter mb12">
                  <el-checkbox v-model="showBorder">显示边框</el-checkbox>
                </div>
                <cx-border
                  v-if="showBorder"
                  :borderWidth.sync="borderWidth"
                  :borderStyle.sync="borderStyle"
                  :borderColor.sync="borderColor"
                  :borderIsThemeColor.sync="borderIsThemeColor"
                />
              </div>
              <div class="content-item mt12">
                <border-radius
                  :borderTypeFlag.sync="borderTypeFlag"
                  :borderRadius.sync="borderRadius"
                  :borderTopLeftRadius.sync="borderTopLeftRadius"
                  :borderTopRightRadius.sync="borderTopRightRadius"
                  :borderBottomRightRadius.sync="borderBottomRightRadius"
                  :borderBottomLeftRadius.sync="borderBottomLeftRadius"
                />
              </div>
            </div>
          </div>
        </el-collapse-item>
        <el-collapse-item title="边距" name="5">
          <div class="setting-item">
            <div class="content">
              <div class="content-item">
                <cx-padding
                  :paddingTypeFlag.sync="topPaddingTypeFlag"
                  :padding.sync="padding"
                  :paddingTop.sync="paddingTop"
                  :paddingRight.sync="paddingRight"
                  :paddingBottom.sync="paddingBottom"
                  :paddingLeft.sync="paddingLeft"
                />
              </div>
            </div>
          </div>
        </el-collapse-item>
        <el-collapse-item title="更多" name="6">
          <cx-slider
            v-if="request_prefix === 'stage' "
            label="触发方式"
            :value.sync="menuTrigger"
            :options="[
              { title: '悬浮', value: 'hover' },
              { title: '点击', value: 'click' }
            ]"
            :showToolTip="false"
          />
          <div class="mt12">
            <div class="content">
              <div class="verticallyCenter">
                <slider-and-input
                  inputWidth="small"
                  inputHeight="small"
                  :value.sync="opacity"
                  title="透明度"
                  :sliderMax="100"
                  suffix="%"
                />
              </div>
              <div class="content-item mt16">
                <div class="checkbox_colorPicker_container">
                  <span>阴影</span>
                  <span class="icon-portal-plus theme-color right-icon" @click="addBoxshadow('b')"></span>
                </div>
                <box-shadow
                  :boxShadowH.sync="boxShadowH"
                  :boxShadowV.sync="boxShadowV"
                  :boxShadowBlur.sync="boxShadowBlur"
                  :boxShadowSpread.sync="boxShadowSpread"
                  :boxShadowColor.sync="boxShadowColor"
                />
              </div>
<!--              <div class="content-item mt16">-->
<!--                <el-checkbox v-model="showVerticalType">开启竖向导航</el-checkbox>-->
<!--              </div>-->
            </div>
          </div>
        </el-collapse-item>
      </template>
      <template v-if="curNav !== 0">
        <div class="navBackBox" @click="changeNav(0, false)">
          <i class="navBackIcon icon-portal-arrows-left"></i>
          <span class="navBackTitle">{{ navName }}</span>
        </div>
        <!-- <cx-slider
          v-if="curNav === 2"
          class="rect-active-slider"
          :value.sync="liActiveType"
          :options="liActiveTypeOptions"
        /> -->
        <cx-slider
          v-if="liActiveType !== '2' && curNav === 1"
          class="rect-active-slider"
          label="状态"
          :value.sync="activeType"
          :options="activeTypeOptions"
        />
        <!-- 一级导航 菜单 -->
        <template v-if="curNav === 1">
          <!-- 一级导航 默认 -->
          <template v-if="activeType === '1'">
            <widthAndHeightSize
              :widthVal.sync="navWidth"
              :heightVal.sync="navHeight"
              :widthAuto.sync="widthAuto"
              :heightAuto.sync="heightAuto"
            />
            <el-collapse-item title="文字" name="10">
              <div>
                <text-setting-complex-update
                  :fontFamily.sync="fontFamily"
                  :fontSize.sync="fontSize"
                  :fontWeight.sync="fontWeight"
                  :fontStyle.sync="fontStyle"
                  :textDecoration.sync="textDecoration"
                  :lineHeight.sync="lineHeight"
                  :lineHeightType.sync="lineHeightType"
                  :letterSpacing.sync="letterSpacing"
                  :activeArrangement.sync="activeArrangement"
                  :writingMode.sync="writingMode"
                  :textAlign.sync="textAlign"
                  :activeArrangementOrder.sync="activeArrangementOrder"
                  :isThemeColor.sync="textIsThemeColor"
                  :colorArr.sync="color"
                  :enableVerticalAlign="true"
                  :verticalAlign.sync="verticalAlign"
                  :showOverflowSetting="true"
                  :contentHasLimit.sync="topNavTextLimit"
                  :contentHasLimitRadio.sync="topNavTextLimitRadio"
                  :textLimitWords.sync="topNavTextLimitCount"
                  :textLimitLines.sync="topNavTextLimitLines"
                  :showHoverSet="request_prefix ==='stage'?true:false"
                  :hoverShowAllContent.sync="hoverShowAllContent"
                  :showHideText="true"
                  :options="options"
                />
                <div class="mt16" v-if="directionMode === 'vertical'">
                  <el-checkbox v-model="collapse">折叠收起菜单</el-checkbox>
                </div>
              </div>
            </el-collapse-item>
            <el-collapse-item title="背景" name="11">
              <div>
                <cx-background :background.sync="topNavBackground" imgType="10" />
              </div>
            </el-collapse-item>
            <el-collapse-item title="图标" name="7">
              <el-checkbox v-model="showTopNavIcon">显示图标</el-checkbox>
              <div class="content-item mt12" v-if="showTopNavIcon">
                <img-icon-upload
                  class="mb16"
                  :imgSrc.sync="iconSrc"
                  :iconType.sync="iconType"
                  :iconColor.sync="iconColor"
                  :resInfo.sync="resInfo"
                />
                <div v-show="iconSrc.length" class="content-item mb16 verticallyCenter">
                  <span class="mr16 fs14">位置</span>
                  <el-radio-group v-model="iconPosition">
                    <el-radio label="left">左</el-radio>
                    <el-radio label="right">右</el-radio>
                  </el-radio-group>
                </div>
                <div class="verticallyCenter mb16" v-if="iconType === 'icon'">
                  <span class="mr16 fs14">颜色</span>
                  <cx-color-picker class="flex1" :isThemeColor.sync="iconColorIsThemeColor" :colorArr.sync="iconColor">
                  </cx-color-picker>
                </div>

                <slider-and-input class="mb16" :value.sync="iconWidth" title="大小" :sliderMax="navWidth" suffix="px" />
                <slider-and-input :value.sync="iconMargin" title="间距" :sliderMax="navWidth" suffix="px" />
              </div>
            </el-collapse-item>
            <el-collapse-item title="分隔符" name="35">
              <el-checkbox v-model="showDivide">显示分隔符</el-checkbox>
              <div class="content-item mt12" v-if="showDivide">
                <cx-slider label="类型" :value.sync="divideType" :options="divideTypeOptions" />
                <div class="mt12" v-if="divideType === 'custom'">
                  <img-icon-upload
                    :imgSrc.sync="divideIconSrc"
                    :iconType.sync="divideIconType"
                    :iconColor.sync="divideIconColor"
                    :resInfo.sync="divideResInfo"
                  />
                  <div class="verticallyCenter mt12" v-if="divideIconType !== 'img'">
                    <span class="mr16 fs14">颜色</span>
                    <cx-color-picker class="flex1" :isThemeColor.sync="divideIconColorIsThemeColor" :colorArr.sync="divideIconColor">
                    </cx-color-picker>
                  </div>
                  <!-- <slider-and-input class="mt12" :value.sync="divideIconWidth" title="大小" :sliderMax="navWidth" suffix="px" /> -->
                </div>
                <div class="mt12" v-else>
                  <div class="verticallyCenter">
                    <span class="mr16 fs14">颜色</span>
                    <cx-color-picker class="flex1" :isThemeColor.sync="iconColorIsThemeColor" :colorArr.sync="divideIconColor">
                    </cx-color-picker>
                  </div>
                </div>
                <div class="verticallyCenter mt12">
                  <span class="mr16 fs14">尺寸</span>
                  <div class="verticallyCenter mr16 flex1">
                    <single-input
                      class="input-size"
                      placeholder="-"
                      :value.sync="divideWidth"
                      :min="1"
                      inputSuffixs="宽"
                     />
                    </div>
                  <div class="verticallyCenter flex1">
                    <single-input
                      class="input-size"
                      placeholder="-"
                      :value.sync="divideHeight"
                      :min="1"
                      inputSuffixs="高"
                    />
                  </div>
                </div>
              </div>
            </el-collapse-item>
            <el-collapse-item title="边框" name="12">
              <el-checkbox v-model="showTopNavBorder">显示边框</el-checkbox>
              <div>
                <div class="mt16" v-if="showTopNavBorder">
                  <span>边框</span>
                  <cx-border
                    :borderWidth.sync="topNavBorderWidth"
                    :borderStyle.sync="topNavBorderStyle"
                    :borderColor.sync="topNavBorderColor"
                    :borderIsThemeColor.sync="topNavBorderIsThemeColor"
                  />
                </div>
                <border-radius
                  class="mt16"
                  :borderTypeFlag.sync="topNavBorderTypeFlag"
                  :borderRadius.sync="topNavBorderRadius"
                  :borderTopLeftRadius.sync="topNavBorderTopLeftRadius"
                  :borderTopRightRadius.sync="topNavBorderTopRightRadius"
                  :borderBottomRightRadius.sync="topNavBorderBottomRightRadius"
                  :borderBottomLeftRadius.sync="topNavBorderBottomLeftRadius"
                />
              </div>
            </el-collapse-item>
            <el-collapse-item title="边距" name="13">
              <div>
                <cx-padding
                  :paddingTypeFlag.sync="topNavPaddingTypeFlag"
                  :padding.sync="topNavPadding"
                  :paddingTop.sync="topNavPaddingTop"
                  :paddingRight.sync="topNavPaddingRight"
                  :paddingBottom.sync="topNavPaddingBottom"
                  :paddingLeft.sync="topNavPaddingLeft"
                />
              </div>
            </el-collapse-item>
            <el-collapse-item title="更多" name="14">
              <div>
                <div class="verticallyCenter">
                  <slider-and-input
                    inputWidth="small"
                    inputHeight="small"
                    :value.sync="topNavOpacity"
                    title="透明度"
                    :sliderMax="100"
                    suffix="%"
                  />
                </div>
                <div class="mt16">
                  <slider-and-input class="mt8" :value.sync="topNavRotate" title="旋转" :sliderMax="360" suffix="度" />
                </div>
                <div class="mt16">
                  <div class="checkbox_colorPicker_container">
                    <span>阴影</span>
                    <span class="icon-portal-plus theme-color right-icon" @click="addBoxshadow('topNavB')"></span>
                  </div>
                  <box-shadow
                    :boxShadowH.sync="topNavBoxShadowH"
                    :boxShadowV.sync="topNavBoxShadowV"
                    :boxShadowBlur.sync="topNavBoxShadowBlur"
                    :boxShadowSpread.sync="topNavBoxShadowSpread"
                    :boxShadowColor.sync="topNavBoxShadowColor"
                  ></box-shadow>
                </div>
              </div>
            </el-collapse-item>
          </template>
          <!-- 一级导航 选中 -->
          <template v-if="activeType === '2'">
            <el-collapse-item title="文字" name="32">
              <div>
                <text-setting-complex-update
                  :fontFamily.sync="activeFontFamily"
                  :fontSize.sync="activeFontSize"
                  :fontWeight.sync="activeFontWeight"
                  :fontStyle.sync="activeFontStyle"
                  :textDecoration.sync="activeTextDecoration"
                  :lineHeight.sync="activeLineHeight"
                  :lineHeightType.sync="activeLineHeightType"
                  :letterSpacing.sync="activeLetterSpacing"
                  :activeArrangement.sync="activeActiveArrangement"
                  :writingMode.sync="activeWritingMode"
                  :textAlign.sync="activeTextAlign"
                  :activeArrangementOrder.sync="activeArrangementOrder"
                  :isThemeColor.sync="activeTextIsThemeColor"
                  :colorArr.sync="activeFontColor"
                  :verticalAlign.sync="activeVerticalAlign"
                  :enableVerticalAlign="true"
                  :contentHasLimit.sync="topNavActiveTextLimit"
                  :showOverflowSetting="false"
                  :textLimitWords.sync="topNavActiveTextLimitCount"
                  :options="options"
                />
              </div>
            </el-collapse-item>
            <el-collapse-item title="背景" name="15">
              <div>
                <cx-background :background.sync="activeBgColor" imgType="10" />
              </div>
            </el-collapse-item>
            <el-collapse-item title="边框" name="16">
              <el-checkbox v-model="showTopNavActiveBorder">显示边框</el-checkbox>
              <div v-if="showTopNavActiveBorder">
                <cx-border
                  :borderWidth.sync="activeBorderWidth"
                  :borderStyle.sync="activeBorderStyle"
                  :borderColor.sync="activeBorderColor"
                  :borderIsThemeColor.sync="activeBorderIsThemeColor"
                />
              </div>
              <border-radius
                class="mt16"
                :borderTypeFlag.sync="topNavActiveBorderTypeFlag"
                :borderRadius.sync="topNavActiveBorderRadius"
                :borderTopLeftRadius.sync="topNavActiveBorderTopLeftRadius"
                :borderTopRightRadius.sync="topNavActiveBorderTopRightRadius"
                :borderBottomRightRadius.sync="topNavActiveBorderBottomRightRadius"
                :borderBottomLeftRadius.sync="topNavActiveBorderBottomLeftRadius"
              />
            </el-collapse-item>
          </template>
          <!-- 一级导航 悬浮 -->
          <template v-if="activeType === '3'">
            <el-checkbox class="paddingl15 mb12 mt8" v-model="hoverIsSameActive">同选中状态</el-checkbox>
            <template v-if="!hoverIsSameActive">
              <el-collapse-item title="文字" name="33">
                <div>
                  <text-setting-complex-update
                    :fontFamily.sync="hoverFontFamily"
                    :fontSize.sync="hoverFontSize"
                    :fontWeight.sync="hoverFontWeight"
                    :fontStyle.sync="hoverFontStyle"
                    :textDecoration.sync="hoverTextDecoration"
                    :lineHeight.sync="hoverLineHeight"
                    :lineHeightType.sync="hoverLineHeightType"
                    :letterSpacing.sync="hoverLetterSpacing"
                    :activeArrangement.sync="hoverActiveArrangement"
                    :writingMode.sync="hoverWritingMode"
                    :textAlign.sync="hoverTextAlign"
                    :activeArrangementOrder.sync="hoverActiveArrangementOrder"
                    :isThemeColor.sync="hoverTextIsThemeColor"
                    :colorArr.sync="hoverFontColor"
                    :enableVerticalAlign="true"
                    :verticalAlign.sync="hoverVerticalAlign"
                    :options="options"
                  />
                  <div class="mt16" style="display: none">
                    <el-checkbox v-model="hoverTextLimit">字数限制</el-checkbox>
                    <div v-show="hoverTextLimit" class="content-item card mt16">
                      <div class="content-item fs14 verticallyCenter count-limit-item">
                        <span class="mr16">超出</span>
                        <single-input
                          class="size-inp mr8"
                          style="width: 90px; height: 32px"
                          :value.sync="hoverTextLimitCount"
                          inputSuffixs="字"
                        />
                        <span>隐藏</span>
                      </div>
                    </div>
                  </div>
                </div>
              </el-collapse-item>
              <el-collapse-item title="背景" name="17">
                <div>
                  <cx-background :background.sync="hoverBgColor" imgType="10" />
                </div>
              </el-collapse-item>
              <el-collapse-item title="边框" name="18">
                <el-checkbox v-model="showTopNavHoverBorder">显示边框</el-checkbox>
                <div v-if="showTopNavHoverBorder" class="mt16">
                  <span>边框</span>
                  <cx-border
                    :borderWidth.sync="hoverBorderWidth"
                    :borderStyle.sync="hoverBorderStyle"
                    :borderColor.sync="hoverBorderColor"
                    :borderIsThemeColor.sync="hoverBorderIsThemeColor"
                  />
                </div>
                <border-radius
                  class="mt16"
                  :borderTypeFlag.sync="topNavHoverBorderTypeFlag"
                  :borderRadius.sync="topNavHoverBorderRadius"
                  :borderTopLeftRadius.sync="topNavHoverBorderTopLeftRadius"
                  :borderTopRightRadius.sync="topNavHoverBorderTopRightRadius"
                  :borderBottomRightRadius.sync="topNavHoverBorderBottomRightRadius"
                  :borderBottomLeftRadius.sync="topNavHoverBorderBottomLeftRadius"
                />
              </el-collapse-item>
            </template>
          </template>
        </template>
        <!-- 二级导航 菜单 -->
        <template v-if="curNav === 2">
          <CustomSubMenuSetting
            :currentSetStyle.sync="currentSetStyle"
            :selectOptions="options.selectOptions"
            :options="options"
            :currentSetMenu.sync="currentSetMenu"
            :subMenuConfig.sync="subMenuConfig"
            :rectId="ids.rect_id"
          ></CustomSubMenuSetting>
          <el-collapse v-model="submenuSetNames" v-if="currentSetStyle != 2 && currentSetStyle != 3 && currentSetStyle != 4">
            <el-collapse-item title="菜单项" name="1" class="submenu-container">
              <cx-slider
                class="rect-active-slider"
                label="状态"
                :value.sync="activeType"
                :options="activeTypeOptions"
              />
              <!-- 二级导航 默认 -->
              <div v-if="activeType === '1'" class="sub-menu-setting">
                <widthAndHeightSize
                      :widthVal.sync="liWidth"
                      :heightVal.sync="liHeight"
                      :widthAuto.sync="liWidthAuto"
                      :heightAuto.sync="liIsSameSizeHeight"
                      :showMinMax.sync="showMinMax1"
                      :showMinWidth1.sync="liShowMinWidth"
                      :showMaxWidth1.sync="liShowMaxWidth"
                      :minWidth1.sync="liMinWidthVal"
                      :maxWidth1.sync="liMaxWidthVal"
                    />
                <el-collapse v-model="menuItemNames">
                  <el-collapse-item title="文字" name="19">
                    <div>
                      <text-setting-complex-update
                        class=""
                        :fontFamily.sync="liFontFamily"
                        :fontSize.sync="liFontSize"
                        :fontWeight.sync="liFontWeight"
                        :fontStyle.sync="liFontStyle"
                        :textDecoration.sync="liTextDecoration"
                        :lineHeight.sync="liLineHeight"
                        :lineHeightType.sync="liLineHeightType"
                        :letterSpacing.sync="liLetterSpacing"
                        :activeArrangement.sync="liActiveArrangement"
                        :writingMode.sync="liWritingMode"
                        :textAlign.sync="liTextAlign"
                        :activeArrangementOrder.sync="liActiveArrangementOrder"
                        :isThemeColor.sync="liIsThemeColor"
                        :colorArr.sync="liFontColor"
                        :options="options"
                        :showOverflowSetting="true"
                        :contentHasLimit.sync="liTextLimit"
                        :contentHasLimitRadio="'字数'"
                        :overflowTypes="['字数', '无']"
                        :textLimitWords.sync="liTextLimitCount"
                      />
                      <!--                  <text-vertical-align-setting class="mt8" :verticalAlign.sync="liVerticalAlign" />-->
                    </div>
                  </el-collapse-item>
                  <el-collapse-item title="背景" name="20">
                    <cx-background :background.sync="ulBgColor" imgType="10" />
<!--                    <div class="content-item">-->
<!--                      <span>背景</span>-->
<!--                      <cx-color-picker class="flex1 mt8" :isThemeColor.sync="ulBgIsThemeColor" :colorArr.sync="ulBgColor" infoTips="">-->
<!--                      </cx-color-picker>-->
<!--                    </div>-->
                  </el-collapse-item>
                  <el-collapse-item title="图标" name="21">
                    <el-checkbox v-model="showLiIcon">显示图标</el-checkbox>
                    <div class="content-item mt12" v-if="showLiIcon">
                      <img-icon-upload
                        class="mb16"
                        :imgSrc.sync="liIconSrc"
                        :iconType.sync="liIconType"
                        :iconColor.sync="liIconColor"
                        :resInfo.sync="liResInfo"
                      />
                      <div v-show="liIconSrc.length" class="content-item mb16 verticallyCenter">
                        <span class="mr16 fs14">位置</span>
                        <el-radio-group v-model="liIconPosition">
                          <el-radio label="left">左</el-radio>
                          <el-radio label="right">右</el-radio>
                        </el-radio-group>
                      </div>
                      <div class="verticallyCenter mb16" v-if="liIconType === 'icon'">
                        <span class="mr16 fs14">颜色</span>
                        <cx-color-picker
                          class="flex1"
                          :isThemeColor.sync="liIconColorIsThemeColor"
                          :colorArr.sync="liIconColor"
                        >
                        </cx-color-picker>
                      </div>
                      <slider-and-input
                        class="mb16"
                        :value.sync="liIconWidth"
                        title="大小"
                        :sliderMax="liWidth"
                        suffix="px"
                      />
                      <slider-and-input :value.sync="liIconMargin" title="间距" :sliderMax="liWidth" suffix="px" />
                    </div>
                  </el-collapse-item>
                  <el-collapse-item title="边框" name="22">
                    <el-checkbox v-model="showLiBorder">显示边框</el-checkbox>
                    <div v-if="showLiBorder">
                      <div class="">
                        <cx-border
                          :borderWidth.sync="liBorderWidth"
                          :borderStyle.sync="liBorderStyle"
                          :borderColor.sync="liBorderColor"
                          :borderIsThemeColor.sync="liBorderIsThemeColor"
                        />
                      </div>
                      <div class="mt16">
                        <el-checkbox v-model="clearLiLastBorder">清除最后一个选项的下边框</el-checkbox>
                      </div>
                    </div>
                    <border-radius
                      class="mt16"
                      :borderTypeFlag.sync="liBorderTypeFlag"
                      :borderRadius.sync="liBorderRadius"
                      :borderTopLeftRadius.sync="liBorderTopLeftRadius"
                      :borderTopRightRadius.sync="liBorderTopRightRadius"
                      :borderBottomRightRadius.sync="liBorderBottomRightRadius"
                      :borderBottomLeftRadius.sync="liBorderBottomLeftRadius"
                    />
                  </el-collapse-item>
                  <el-collapse-item title="边距" name="23">
                    <div>
                      <cx-padding
                        :paddingTypeFlag.sync="liPaddingTypeFlag"
                        :padding.sync="liPadding"
                        :paddingTop.sync="liPaddingTop"
                        :paddingRight.sync="liPaddingRight"
                        :paddingBottom.sync="liPaddingBottom"
                        :paddingLeft.sync="liPaddingLeft"
                      />
                    </div>
                  </el-collapse-item>
                  <el-collapse-item title="更多" name="24">
                    <div>
                      <div class="verticallyCenter">
                        <slider-and-input
                          inputWidth="small"
                          inputHeight="small"
                          :value.sync="liOpacity"
                          title="透明度"
                          :sliderMax="100"
                          suffix="%"
                        />
                      </div>
                      <div class="mt16">
                        <slider-and-input class="mt8" :value.sync="liRotate" title="旋转" :sliderMax="360" suffix="度" />
                      </div>
                      <div class="mt16">
                        <slider-and-input class="mt8" :value.sync="liMargin" title="间距" :sliderMax="100" suffix="px" />
                      </div>
                      <div class="content-item mt16">
                        <div class="checkbox_colorPicker_container">
                          <span>阴影</span>
                          <span class="icon-portal-plus theme-color right-icon" @click="addBoxshadow('selectB')"></span>
                        </div>
                        <box-shadow
                          :boxShadowH.sync="selectBoxShadowH"
                          :boxShadowV.sync="selectBoxShadowV"
                          :boxShadowBlur.sync="selectBoxShadowBlur"
                          :boxShadowSpread.sync="selectBoxShadowSpread"
                          :boxShadowColor.sync="selectBoxShadowColor"
                        ></box-shadow>
                      </div>
                        <connectorSet
                          class="mt16"
                          :connectorColor.sync="connectorColor"
                          :connectorWidth.sync="connectorWidth"
                          :showConnector.sync="showConnector"/>
                    </div>
                  </el-collapse-item>
                </el-collapse>
              </div>
              <!-- 二级导航 选中 -->
              <div v-if="activeType === '2'" class="sub-menu-setting">
                <el-collapse v-model="menuItemActiveNames">
                  <el-collapse-item title="文字" name="8">
                    <div>
                      <text-setting-complex-update
                        :fontFamily.sync="liActiveFontFamily"
                        :fontSize.sync="liActiveFontSize"
                        :fontWeight.sync="liActiveFontWeight"
                        :fontStyle.sync="liActiveFontStyle"
                        :textDecoration.sync="liActiveTextDecoration"
                        :lineHeight.sync="liActiveLineHeight"
                        :lineHeightType.sync="liActiveLineHeightType"
                        :letterSpacing.sync="liActiveLetterSpacing"
                        :activeArrangement.sync="liActiveActiveArrangement"
                        :writingMode.sync="liActiveWritingMode"
                        :textAlign.sync="liActiveTextAlign"
                        :activeArrangementOrder.sync="liActiveActiveArrangementOrder"
                        :isThemeColor.sync="liActiveTextIsThemeColor"
                        :colorArr.sync="liActiveFontColor"
                        :options="options"
                      />
                    </div>
                  </el-collapse-item>
                  <el-collapse-item title="背景" name="25">
                    <cx-background :background.sync="liActiveBgColor" :isThemeColor="liActiveBgIsThemeColor" imgType="10" />
                  </el-collapse-item>
                  <el-collapse-item title="边框" name="26">
                    <el-checkbox v-model="showLiActiveBorder">显示边框</el-checkbox>
                    <div v-if="showLiActiveBorder" class="mt16">
                      <cx-border
                        :borderWidth.sync="liActiveBorderWidth"
                        :borderStyle.sync="liActiveBorderStyle"
                        :borderColor.sync="liActiveBorderColor"
                        :borderIsThemeColor.sync="liActiveBorderIsThemeColor"
                      />
                    </div>
                    <border-radius
                      class="mt16"
                      :borderTypeFlag.sync="liActiveBorderTypeFlag"
                      :borderRadius.sync="liActiveBorderRadius"
                      :borderTopLeftRadius.sync="liActiveBorderTopLeftRadius"
                      :borderTopRightRadius.sync="liActiveBorderTopRightRadius"
                      :borderBottomRightRadius.sync="liActiveBorderBottomRightRadius"
                      :borderBottomLeftRadius.sync="liActiveBorderBottomLeftRadius"
                    />
                  </el-collapse-item>
                </el-collapse>
              </div>
              <!-- 二级导航 悬浮 -->
              <div v-if="activeType === '3'" class="sub-menu-setting">
                <el-collapse v-model="menuItemHoverNames">
                  <el-collapse-item title="文字" name="8">
                    <div>
                      <text-setting-complex-update
                        :fontFamily.sync="liHoverFontFamily"
                        :fontSize.sync="liHoverFontSize"
                        :fontWeight.sync="liHoverFontWeight"
                        :fontStyle.sync="liHoverFontStyle"
                        :textDecoration.sync="liHoverTextDecoration"
                        :lineHeight.sync="liHoverLineHeight"
                        :lineHeightType.sync="liHoverLineHeightType"
                        :letterSpacing.sync="liHoverLetterSpacing"
                        :activeArrangement.sync="liHoverActiveArrangement"
                        :writingMode.sync="liHoverWritingMode"
                        :textAlign.sync="liHoverTextAlign"
                        :activeArrangementOrder.sync="liHoverActiveArrangementOrder"
                        :isThemeColor.sync="liHoverTextIsThemeColor"
                        :colorArr.sync="liHoverFontColor"
                        :options="options"
                      />
                      <!--                  <text-vertical-align-setting class="mt8" :verticalAlign.sync="liHoverVerticalAlign" />-->
                      <div class="mt16" style="display: none">
                        <el-checkbox v-model="liHoverTextLimit">字数限制</el-checkbox>
                        <div v-show="liHoverTextLimit" class="content-item card mt16">
                          <div class="content-item fs14 verticallyCenter count-limit-item">
                            <span class="mr16">超出</span>
                            <single-input
                              class="size-inp mr8"
                              style="width: 90px; height: 32px"
                              :value.sync="liHoverTextLimitCount"
                              inputSuffixs="字"
                            />
                            <span>隐藏</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </el-collapse-item>
                  <el-collapse-item title="背景" name="25">
                    <cx-background :background.sync="liHoverBgColor" imgType="10" />
<!--                    <div>-->
<!--                      <span>背景</span>-->
<!--                      <cx-color-picker-->
<!--                        class="flex1 mt8"-->
<!--                        :isThemeColor.sync="liHoverBgIsThemeColor"-->
<!--                        :colorArr.sync="liHoverBgColor"-->
<!--                      >-->
<!--                      </cx-color-picker>-->
<!--                    </div>-->
                  </el-collapse-item>
                  <el-collapse-item title="边框" name="26">
                    <el-checkbox v-model="showLiHoverBorder">显示边框</el-checkbox>
                    <div v-if="showLiHoverBorder" class="mt16">
                      <div>
                      <cx-border
                        :borderWidth.sync="liHoverBorderWidth"
                        :borderStyle.sync="liHoverBorderStyle"
                        :borderColor.sync="liHoverBorderColor"
                        :borderIsThemeColor.sync="liHoverBorderIsThemeColor"
                      />
                      </div>
                      <div class="mt16">
                        <el-checkbox v-model="clearLiLastHoverBorder">清除最后一个选项的下边框</el-checkbox>
                      </div>
                    </div>
                    <border-radius
                      class="mt16"
                      :borderTypeFlag.sync="liHoverBorderTypeFlag"
                      :borderRadius.sync="liHoverBorderRadius"
                      :borderTopLeftRadius.sync="liHoverBorderTopLeftRadius"
                      :borderTopRightRadius.sync="liHoverBorderTopRightRadius"
                      :borderBottomRightRadius.sync="liHoverBorderBottomRightRadius"
                      :borderBottomLeftRadius.sync="liHoverBorderBottomLeftRadius"
                    />
                  </el-collapse-item>
                </el-collapse>
              </div>
            </el-collapse-item>
            <el-collapse-item title="列表项" name="2"  class="submenu-container">
              <div class="sub-menu-setting">
                <!-- <widthAndHeightSize :widthVal.sync="ulWidth" :heightVal.sync="ulHeight" :widthAuto.sync="ulWidthAuto" :heightAuto.sync="ulHeightAuto" /> -->
                <el-collapse v-model="menuListNames">
                  <el-collapse-item title="位置" name="34">
                    <div>
                      <cx-slider label="对齐" :value.sync="ulAlignmentType" :options="alignmentTypeOptions" :showToolTip="true" />
                      <div class="verticallyCenter mt16">
                        <span class="fs14 mr16">间距</span>
                        <div style="width: calc(100% - 44px)">
                          <slider-and-input
                              inputWidth="small"
                              inputHeight="small"
                              :value.sync="ulMarginTop"
                              title=""
                              titlePosition="singleLine"
                              :sliderMax="100"
                              suffix="px"
                          />
                        </div>
                      </div>
                    </div>
                  </el-collapse-item>
                  <el-collapse-item title="背景" name="28">
                    <div>
                      <cx-background :background.sync="ulBackground" imgType="10" />
                    </div>
                  </el-collapse-item>
                  <el-collapse-item title="边框" name="29">
                    <el-checkbox v-model="showUlBorder">显示边框</el-checkbox>
                    <div>
                      <div class="mt16" v-if="showUlBorder">
                        <span>边框</span>
                        <cx-border
                          :borderWidth.sync="ulBorderWidth"
                          :borderStyle.sync="ulBorderStyle"
                          :borderColor.sync="ulBorderColor"
                          :borderIsThemeColor.sync="ulBorderIsThemeColor"
                        />
                      </div>
                      <border-radius
                        class="mt16"
                        :borderTypeFlag.sync="ulBorderTypeFlag"
                        :borderRadius.sync="ulBorderRadius"
                        :borderTopLeftRadius.sync="ulBorderTopLeftRadius"
                        :borderTopRightRadius.sync="ulBorderTopRightRadius"
                        :borderBottomRightRadius.sync="ulBorderBottomRightRadius"
                        :borderBottomLeftRadius.sync="ulBorderBottomLeftRadius"
                      />
                    </div>
                  </el-collapse-item>
                  <el-collapse-item title="边距" name="30">
                    <div>
                      <cx-padding
                        :paddingTypeFlag.sync="ulPaddingTypeFlag"
                        :padding.sync="ulPadding"
                        :paddingTop.sync="ulPaddingTop"
                        :paddingRight.sync="ulPaddingRight"
                        :paddingBottom.sync="ulPaddingBottom"
                        :paddingLeft.sync="ulPaddingLeft"
                      />
                    </div>
                  </el-collapse-item>
                  <el-collapse-item title="更多" name="31">
                    <div>
                      <div class="verticallyCenter">
                        <slider-and-input
                          inputWidth="small"
                          inputHeight="small"
                          :value.sync="ulOpacity"
                          title="透明度"
                          :sliderMax="100"
                          suffix="%"
                        />
                      </div>
                      <div class="mt16">
                        <slider-and-input class="mt8" :value.sync="ulRotate" title="旋转" :sliderMax="360" suffix="度" />
                      </div>
                      <div class="mt16">
                        <div class="checkbox_colorPicker_container">
                          <span>阴影</span>
                          <span class="icon-portal-plus theme-color right-icon" @click="addBoxshadow('ulB')"></span>
                        </div>
                        <box-shadow
                          :boxShadowH.sync="ulBoxShadowH"
                          :boxShadowV.sync="ulBoxShadowV"
                          :boxShadowBlur.sync="ulBoxShadowBlur"
                          :boxShadowSpread.sync="ulBoxShadowSpread"
                          :boxShadowColor.sync="ulBoxShadowColor"
                        ></box-shadow>
                      </div>
<!--                      <div class="mt16">-->
<!--                        <div class="checkbox_colorPicker_container">-->
<!--                          <el-checkbox>显示连接符</el-checkbox>-->
<!--                        </div>-->
<!--                      </div>-->
                    </div>
                  </el-collapse-item>
              </el-collapse>
              </div>
            </el-collapse-item>
          </el-collapse>
          <!-- <el-collapse-item title="设置展开项">
            选择需要展开的二级导航
            <div class="menu-choose-container">
              <el-radio-group v-model="currentSetMenu">
                <el-radio :label="menu.publicId" v-for="menu in options.selectOptions" :key="menu.publicId" style="width: 100%;">{{ menu.label }}</el-radio>
              </el-radio-group>
            </div>
          </el-collapse-item>
          <el-collapse-item title="设置展开项">
            选择需要展开的二级导航
            <div class="menu-choose-container">
              <el-radio-group v-model="currentSetMenu">
                <el-radio :label="menu.publicId" v-for="menu in options.selectOptions" :key="menu.publicId" style="width: 100%;">{{ menu.label }}</el-radio>
              </el-radio-group>
            </div>
          </el-collapse-item> -->
          <!-- 菜单项 -->
          <!-- 列表 -->
        </template>
      </template>
      <el-collapse-item v-show="$store.state.states.showPluginSetting && curNav === 0" title="插件" name="9">
        <div class="setting-item">
          <elementPluginSetting :pluginName="pluginName" :myid="ids"></elementPluginSetting>
        </div>
      </el-collapse-item>
    </el-collapse>
    <el-dialog title="说明" :append-to-body="true" :visible.sync="explainDialog" custom-class="explainDialog">
      <p class="fs14 tips">
        <span>{{ explainTitle }}：</span>{{ explainTips }}
      </p>
      <div class="box">
        <img :src="explainImgSrc" v-if="explainImgSrc" alt="" class="img" />
        <video :src="explainVideoSrc" controls v-if="explainVideoSrc"></video>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import elementPluginSetting from "publicSetting/elementPluginSetting.vue"
import controlWidthAndSizeAndZindex from "publicSetting/controlWidthAndSizeAndZindex.vue"
import rowColLayoutSize from "publicSetting/rowColLayoutSize"
import widthAndHeightSize from "publicSetting/widthAndHeightSize"
import { withMethodsHistoryCombine } from "utils/revork"
import CustomSubMenuSetting from "../render/customSubMenus/setting"
import connectorSet from "../render/customSubMenus/propComponents/connectorSet"
export default withMethodsHistoryCombine({
  components: {
    controlWidthAndSizeAndZindex,
    elementPluginSetting,
    rowColLayoutSize,
    widthAndHeightSize,
    CustomSubMenuSetting,
    connectorSet
  },
  props: {
    options: Object,
    statusOpened: Boolean,
    styleOpened: Boolean
  },
  data() {
    return {
      submenuSetNames: ['1', '2'],
      menuItemNames: ['19', '20'],
      menuItemHoverNames: ['8', '25', '26'],
      menuItemActiveNames: ['8', '25', '26'],
      menuListNames: ['28'],
      currentSetStyle: "",
      currentSetMenu: "",
      activeNames: ["1", "2", "3", "10", "11", "32", "15", "16", "33", "17", "18", "19", "20", "8", "25", "26", "28"],
      this1: this,
      alignmentTypeOptions: [
        {
          value: "left",
          label: "左对齐",
          iconClass: "icon-portal-Align-left"
        },
        {
          value: "center",
          label: "居中对齐",
          iconClass: "icon-portal-Center-lr"
        },
        {
          value: "right",
          label: "右对齐",
          iconClass: "icon-portal-Align-right"
        }
      ],
      explainDialog: false,
      explainTitle: "",
      explainTips: "",
      explainImgSrc: "",
      explainVideoSrc: "",
      curNav: 0,
      navName: "一级导航",
      activeType: "1",
      activeTypeOptions: [
        { value: "1", title: "默认" },
        { value: "2", title: "选中" },
        { value: "3", title: "悬浮" }
      ],
      activeTypeOptions1: [
        { value: "1", title: "默认" },
        { value: "2", title: "选中" },
        { value: "3", title: "悬浮" }
      ],
      activeTypeOptions2: [
        { value: "1", title: "默认" },
        { value: "2", title: "选中" },
        { value: "3", title: "悬浮" }
      ],
      liActiveType: "1",
      liActiveTypeOptions: [
        { value: "1", title: "菜单项" },
        { value: "2", title: "列表" }
      ],
      showMinMax1: true,  //二级导航尺寸最值设置
      divideTypeOptions: [
        {
          value: "line",
          title: "竖线",
        },
        {
          value: "custom",
          title: "自定义",
        },
      ],
    }
  },
  beforeDestroy() {
    this.$eventBus.$emit('enableOpen', this.ids)
  },
  mounted() {
    this.$emit("update:statusOpened", false)
    this.$emit("update:styleOpened", true)
    this.$emit("onHideHeader", false)
    if (!this.options.subMenuConfig) {
      this.$changeOptionsEV([], "subMenuConfig", false, false, false, true)
    }
  },
  methods: {
    // 将激活属性值同步给悬浮属性
    activeValueToHover(){
      for (let i in this.options) {
         let hoverOption
          if(i.indexOf("active")>-1){
            hoverOption = i.replace('active','hover')
          }else if(i.indexOf("Active")>-1){
            hoverOption = i.replace('Active','Hover')
          }
          // this[hoverOption] !== 'undefined' 说明是当前组件可以设置的属性
          if(hoverOption && typeof this[hoverOption] !== 'undefined' && this.options[i] !== this.options[hoverOption]){
           this.$changeOptionsEV(this.options[i], hoverOption, false,'',false,true)
          }
      }
    },
    resetSelectBorder(val) {
      this.liBorderRadius = val
      this.liBorderTopLeftRadius = val
      this.liBorderTopRightRadius = val
      this.liBorderBottomRightRadius = val
      this.liBorderBottomLeftRadius = val
    },
    changeBorderRadiusType(value, hoverFlag) {
      let propName = hoverFlag ? hoverFlag + "BorderTypeFlag" : "borderTypeFlag"
      if (this[propName] === value) {
        return
      }
      this[propName] = value
      // 暂时只处理默认情况  悬浮情况后面有可能会有改动
      this.borderTopRightRadius = this.borderTopLeftRadius
      this.borderBottomLeftRadius = this.borderTopLeftRadius
      this.borderBottomRightRadius = this.borderTopLeftRadius
    },
    addBoxshadow(prefix) {
      if (!Array.isArray(this[`${prefix}oxShadowH`])) {
        this[`${prefix}oxShadowH`] = [this[`${prefix}oxShadowH`]]
        this[`${prefix}oxShadowV`] = [this[`${prefix}oxShadowV`]]
        this[`${prefix}oxShadowBlur`] = [this[`${prefix}oxShadowBlur`]]
        this[`${prefix}oxShadowSpread`] = [this[`${prefix}oxShadowSpread`]]
        this[`${prefix}oxShadowColor`] = [this[`${prefix}oxShadowColor`]]
      }
      let boxShadowH = JSON.parse(JSON.stringify(this[`${prefix}oxShadowH`]))
      let boxShadowV = JSON.parse(JSON.stringify(this[`${prefix}oxShadowV`]))
      let boxShadowBlur = JSON.parse(JSON.stringify(this[`${prefix}oxShadowBlur`]))
      let boxShadowSpread = JSON.parse(JSON.stringify(this[`${prefix}oxShadowSpread`]))
      let boxShadowColor = JSON.parse(JSON.stringify(this[`${prefix}oxShadowColor`]))
      boxShadowH.push(0)
      boxShadowV.push(4)
      boxShadowBlur.push(4)
      boxShadowSpread.push(0)
      boxShadowColor.push("rgba(0,0,0,0.25)")
      this[`${prefix}oxShadowH`] = boxShadowH
      this[`${prefix}oxShadowV`] = boxShadowV
      this[`${prefix}oxShadowBlur`] = boxShadowBlur
      this[`${prefix}oxShadowSpread`] = boxShadowSpread
      this[`${prefix}oxShadowColor`] = boxShadowColor
    },
    getFocus(event) {
      event.currentTarget.select()
    },
    explainDialogClick() {
      this.explainDialog = true
      this.explainTitle = "尺寸自动"
      this.explainTips = "开启后，下拉列表项的宽度、高度会自适应至合适高度，不能手动调整"
    },
    changeNav(val, flag) {
      this.curNav = val
      if (val === 1) {
        this.navName = "一级导航"
        this.activeTypeOptions = this.activeTypeOptions1
      } else if (val === 2) {
        this.navName = "二级导航"
        this.activeTypeOptions = this.activeTypeOptions2

      }
      this.$emit("update:statusOpened", flag)
      this.$emit("update:styleOpened", !flag)
      this.$emit("onHideHeader", flag)
      if (val === 0) {
        this.$eventBus.$emit('enableOpen', this.ids)
      }
      if (val === 2) {
        // 通知导航，暂时屏蔽导航上的点击、悬浮弹出功能
        // 同时打开第一个有children的导航
        const firstSubNav = this.options.selectOptions.find(item => item?.children?.length)
        firstSubNav && this.$eventBus.$emit('openSelectedSubMenu', {
          rect_id: this.ids.rect_id,
          publicId: firstSubNav.publicId
        })
      }
    }
  },
  computed: {
    subMenuConfig: {
      get() {
        return JSON.parse(JSON.stringify(this.options.subMenuConfig || []))
      },
      set(val) {
        return this.$changeOptionsEV(val, 'subMenuConfig', false)
      }
    },
    ids() {
      return this.$store.state.states.activeID
    },
    pluginName: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "pluginName", "pluginName", [])
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "pluginName", false)
      }
    },
    alignmentType: {
      get() {
        return this.options.alignmentType || "left"
      },
      set(val) {
        this.$changeOptionsEV(val, "alignmentType", false)
      }
    },
    directionMode: {
      get() {
        return this.options.mode
      },
      set(val) {
        this.$changeOptionsEV(val, "mode", false)
      }
    },
    menuTrigger: {
      get() {
        return this.options.menuTrigger
      },
      set(val) {
        this.$changeOptionsEV(val, "menuTrigger", false)
      }
    },
    collapse: {
      get() {
        return this.options.collapse
      },
      set(val) {
        this.$changeOptionsEV(val, "collapse", false)
      }
    },
    opacity: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "opacity", "opacity", 100)
      },
      set(newVal) {
        newVal !== this.opacity && this.$changeOptionsEV(newVal, "opacity", false)
      }
    },
    background: {
      get() {
        let background = this.options.background
        if (background && Array.isArray(background) && background.length > 0) {
          return this.options.background
        }
        let newBackground = [
          {
            type: "color",
            label: "颜色",
            isThemeColor: false,
            color: this.options.bgColor
          }
        ]
        this.$changeOptionsEV(newBackground, "background", false, false, false, true)
        return newBackground
      },
      set(val) {
        this.$changeOptionsEV(val, "background", false)
      }
    },
    iconPosition: {
      get() {
        return this.options.iconPosition
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "iconPosition", false)
      }
    },
    showTopNavIcon: {
      get() {
        let hasIconSic = false
        if (this.options.showTopNavIcon === undefined) {
          if (this.options.iconSrc.length > 0) {
            hasIconSic = true
          } else {
            hasIconSic = false
          }
        } else {
          hasIconSic = this.options.showTopNavIcon
        }
        return hasIconSic
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "showTopNavIcon", false)
      }
    },
    iconSrc: {
      get() {
        return this.options.iconSrc
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "iconSrc", false)
      }
    },
    iconType: {
      get() {
        return this.options.iconType
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "iconType", false)
      }
    },
    iconWidth: {
      get() {
        return this.options.iconWidth
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "iconWidth", false)
      }
    },
    iconMargin: {
      get() {
        return this.options.iconMargin
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "iconMargin", false)
      }
    },
    iconColor: {
      get() {
        return this.options.iconColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "iconColor", false)
      }
    },
    iconColorIsThemeColor: {
      get() {
        return this.options.iconColorIsThemeColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "iconColorIsThemeColor", false)
      }
    },
    activeArrangement() {
      return this.options.textAlign
    },
    topNavBackground: {
      get() {
        let background = this.options.topNavBackground
        if (background && Array.isArray(background) && background.length > 0) {
          return this.options.topNavBackground
        }
        let newBackground = [
          {
            type: "color",
            label: "颜色",
            isThemeColor: false,
            color: this.options.bgColor
          }
        ]
        this.$changeOptionsEV(newBackground, "topNavBackground", false, false, false, true)
        return newBackground
      },
      set(val) {
        this.$changeOptionsEV(val, "topNavBackground", false)
      }
    },
    topNavTextLimitCount: {
      get() {
        return this.options.topNavTextLimitCount
      },
      set(val) {
        this.$changeOptionsEV(val, "topNavTextLimitCount", false)
      }
    },
    topNavTextLimitLines: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "topNavTextLimitLines", "topNavTextLimitLines", 1)
      },
      set(val) {
        this.$changeOptionsEV(val, "topNavTextLimitLines", false)
      }
    },
    topNavTextLimit: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "topNavTextLimit", "topNavTextLimit", false)
      },
      set(val) {
        this.$changeOptionsEV(val, "topNavTextLimit", false)
      }
    },
    topNavTextLimitRadio: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "topNavTextLimitRadio", "topNavTextLimitRadio", "行数")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "topNavTextLimitRadio", false)
      }
    },
    activeArrangementOrder: {
      get() {
        return {
          _class: "icon-portal-text-down1",
          isActive: this.options.writingMode === "vertical-lr" ? true : false
        }
      },
      set(newVal) {
        let val = newVal ? "vertical-lr" : "horizontal-tb"
        this.$changeOptionsEV(val, "writingMode", false)
      }
    },
    fontFamily: {
      get() {
        return this.options.fontFamily
      },
      set(val) {
        this.$changeOptionsEV(val, "fontFamily", false)
      }
    },
    fontSize: {
      get() {
        return this.options.fontSize
      },
      set(val) {
        this.$changeOptionsEV(val, "fontSize", false)
      }
    },
    fontWeight: {
      get() {
        return this.options.fontWeight
      },
      set(val) {
        this.$changeOptionsEV(val, "fontWeight", false)
      }
    },
    fontColor: {
      get() {
        return this.options.fontColor
      },
      set(val) {
        this.$changeOptionsEV(val, "fontColor", false)
      }
    },
    letterSpacing: {
      get() {
        return this.options.letterSpacing
      },
      set(newVal) {
        this.$changeOptionsEV(`${newVal}`, "letterSpacing", false)
      }
    },
    lineHeight: {
      get() {
        return this.options.lineHeight
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "lineHeight", false)
      }
    },
    lineHeightType:{
      get() {
        return this.checkAndSetPrimaryVal(this.options, "lineHeightType", "lineHeightType", "px")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "lineHeightType", false)
        /**/
      }
    },
    fontStyle: {
      get() {
        return this.options.fontStyle
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "fontStyle", false)
      }
    },
    textAlign: {
      get() {
        return this.options.textAlign
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "textAlign", false)
      }
    },
    verticalAlign: {
      get() {
        return this.options.verticalAlign || "top"
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "verticalAlign", false)
      }
    },
    color: {
      get() {
        return this.options.color
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "color", false)
      }
    },
    textIsThemeColor: {
      get() {
        return this.options.textIsThemeColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "textIsThemeColor", false)
      }
    },
    writingMode: {
      get() {
        return this.options.writingMode
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "writingMode", false)
      }
    },
    textDecoration: {
      get() {
        return this.options.textDecoration
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "textDecoration", false)
      }
    },
    bgColor: {
      get() {
        return this.options.bgColor
      },
      set(val) {
        this.$changeOptionsEV(val, "bgColor", false)
      }
    },
    bgIsThemeColor: {
      get() {
        return this.options.bgIsThemeColor
      },
      set(val) {
        this.$changeOptionsEV(val, "bgIsThemeColor", false)
      }
    },
    borderColor: {
      get() {
        return this.options.borderColor
      },
      set(val) {
        this.$changeOptionsEV(val, "borderColor", false)
      }
    },
    showBorder: {
      get() {
        let showBorder = false
        if (this.options.showBorder === undefined) {
          if (Array.isArray(this.options.borderWidth)) {
            let allZero = true
            for (let i = 0; i < this.options.borderWidth.length; i++) {
              if (this.options.borderWidth[i] !== 0) {
                allZero = false
              }
            }
            if (allZero) {
              showBorder = false
            } else {
              showBorder = true
            }
          } else {
            if (this.options.borderWidth) {
              showBorder = true
            } else {
              showBorder = false
            }
          }
        } else {
          showBorder = this.options.showBorder
        }
        return showBorder
      },
      set(newVal) {
        if(newVal && !this.borderWidth) {
          this.$changeOptionsEV([1, newVal], ["borderWidth", "showBorder"], false)
        } else {
          this.$changeOptionsEV(newVal, "showBorder", false)
        }
      }
    },
    borderWidth: {
      get() {
        return this.options.borderWidth
      },
      set(val) {
        this.$changeOptionsEV(val, "borderWidth", false)
      }
    },
    borderStyle: {
      get() {
        return this.options.borderStyle
      },
      set(val) {
        this.$changeOptionsEV(val, "borderStyle", false)
      }
    },
    borderIsThemeColor: {
      get() {
        return this.options.borderIsThemeColor
      },
      set(val) {
        this.$changeOptionsEV(val, "borderIsThemeColor", false)
      }
    },
    showTopNavBorder: {
      get() {
        let showTopNavBorder = false
        if (this.options.showTopNavBorder === undefined) {
          if (Array.isArray(this.options.topNavBorderWidth)) {
            let allZero = true
            for (let i = 0; i < this.options.topNavBorderWidth.length; i++) {
              if (this.options.topNavBorderWidth[i] !== 0) {
                allZero = false
              }
            }
            if (allZero) {
              showTopNavBorder = false
            } else {
              showTopNavBorder = true
            }
          } else {
            if (this.options.topNavBorderWidth) {
              showTopNavBorder = true
            } else {
              showTopNavBorder = false
            }
          }
        } else {
          showTopNavBorder = this.options.showTopNavBorder
        }
        return showTopNavBorder
      },
      set(newVal) {
        if(newVal && !this.topNavBorderWidth) {
          this.$changeOptionsEV([1, newVal], ["topNavBorderWidth", "showTopNavBorder"], false)
        } else {
          this.$changeOptionsEV(newVal, "showTopNavBorder", false)
        }
      }
    },
    topNavBorderColor: {
      get() {
        return this.options.topNavBorderColor
      },
      set(val) {
        this.$changeOptionsEV(val, "topNavBorderColor", false)
      }
    },
    topNavBorderWidth: {
      get() {
        return this.options.topNavBorderWidth
      },
      set(val) {
        this.$changeOptionsEV(val, "topNavBorderWidth", false)
      }
    },
    topNavBorderStyle: {
      get() {
        return this.options.topNavBorderStyle
      },
      set(val) {
        this.$changeOptionsEV(val, "topNavBorderStyle", false)
      }
    },
    topNavBorderIsThemeColor: {
      get() {
        return this.options.topNavBorderIsThemeColor
      },
      set(val) {
        this.$changeOptionsEV(val, "topNavBorderIsThemeColor", false)
      }
    },
    topNavBorderTypeFlag: {
      get() {
        let defaultType = 1
        // if (!this.options.hasOwnProperty("topNavBorderTypeFlag")) {
        //   if (
        //     ((this.topNavBorderTopLeftRadius === this.topNavBorderTopRightRadius) ===
        //       this.topNavBorderBottomLeftRadius) ===
        //     this.topNavBorderBottomRightRadius
        //   ) {
        //     defaultType = 2
        //   }
        // }
        // return this.checkAndSetPrimaryVal(this.options, "borderTypeFlag", "borderTypeFlag", defaultType)
        // 上面方法貌似是执行需要一定的时间，造成最开始还未写入值，进行点击 会出现问题
        return this.options.topNavBorderTypeFlag
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "topNavBorderTypeFlag", false)
      }
    },
    topNavBorderRadius: {
      get() {
        return Number(this.options.topNavBorderRadius)
      },
      set(newVal) {
        this.$changeOptionsEV(
          [newVal, newVal, newVal, newVal, newVal],
          [
            "topNavBorderRadius",
            "topNavBorderTopLeftRadius",
            "topNavBorderTopRightRadius",
            "topNavBorderBottomRightRadius",
            "topNavBorderBottomLeftRadius"
          ],
          false
        )
      }
    },
    topNavBorderTopLeftRadius: {
      get() {
        return Number(this.options.topNavBorderTopLeftRadius)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "topNavBorderTopLeftRadius", false)
      }
    },
    topNavBorderTopRightRadius: {
      get() {
        return Number(this.options.topNavBorderTopRightRadius)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "topNavBorderTopRightRadius", false)
      }
    },
    topNavBorderBottomRightRadius: {
      get() {
        return Number(this.options.topNavBorderBottomRightRadius)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "topNavBorderBottomRightRadius", false)
      }
    },
    topNavBorderBottomLeftRadius: {
      get() {
        return Number(this.options.topNavBorderBottomLeftRadius)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "topNavBorderBottomLeftRadius", false)
      }
    },
    topNavBoxShadowColor: {
      get() {
        return this.options.topNavBoxShadowColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "topNavBoxShadowColor", false)
      }
    },
    topNavBoxShadowH: {
      get() {
        return this.options.topNavBoxShadowH
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "topNavBoxShadowH", false)
      }
    },
    topNavBoxShadowV: {
      get() {
        return this.options.topNavBoxShadowV
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "topNavBoxShadowV", false)
      }
    },
    topNavBoxShadowBlur: {
      get() {
        return this.options.topNavBoxShadowBlur
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "topNavBoxShadowBlur", false)
      }
    },
    topNavBoxShadowSpread: {
      get() {
        return this.options.topNavBoxShadowSpread
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "topNavBoxShadowSpread", false)
      }
    },
    // 边距
    topNavPaddingTypeFlag: {
      get() {
        let defaultType = 1
        if (!this.options.hasOwnProperty("topNavPaddingTypeFlag") || this.options.topNavPaddingTypeFlag === undefined) {
          if (
            ((this.topNavPaddingTop === this.topNavPaddingRight) === this.topNavPaddingLeft) ===
            this.topNavPaddingBottom
          ) {
            defaultType = 2
          }
          if (this.topNavPaddingTop === undefined) {
            defaultType = 2
          }
        } else if (this.options.topNavPaddingTypeFlag !== undefined) {
          defaultType = this.options.topNavPaddingTypeFlag
        }
        return defaultType
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "topNavPaddingTypeFlag", false)
      }
    },
    topNavPadding: {
      get() {
        return this.options.topNavPadding !== undefined ? this.options.topNavPadding : 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "topNavPadding", false)
      }
    },
    topNavPaddingTop: {
      get() {
        return this.options.topNavPaddingTop !== undefined ? this.options.topNavPaddingTop : 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "topNavPaddingTop", false)
      }
    },
    topNavPaddingRight: {
      get() {
        return this.options.topNavPaddingRight !== undefined ? this.options.topNavPaddingRight : 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "topNavPaddingRight", false)
      }
    },
    topNavPaddingLeft: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "topNavPaddingLeft", "topNavPaddingLeft", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "topNavPaddingLeft", false)
      }
    },
    topNavPaddingBottom: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "topNavPaddingBottom", "topNavPaddingBottom", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "topNavPaddingBottom", false)
      }
    },
    topNavOpacity: {
      get() {
        return this.options.topNavOpacity
      },
      set(val) {
        this.$changeOptionsEV(val, "topNavOpacity", false)
      }
    },
    topNavRotate: {
      get() {
        return this.options.topNavRotate || 0
      },
      set(val) {
        this.$changeOptionsEV(val, "topNavRotate", false)
      }
    },
    liWidthAuto: {
      get() {
        let liWidthAuto = false
        if (this.options.liWidthAuto === undefined) {
          liWidthAuto = false
        } else {
          liWidthAuto = this.options.liWidthAuto
        }
        return liWidthAuto
      },
      set(val) {
        this.$changeOptionsEV(val, "liWidthAuto", false)
      }
    },
    liIsSameSizeHeight: {
      get() {
        let liHeightAuto = false
        if (this.options.liIsSameSizeHeight !== undefined) {
          liHeightAuto = this.options.liIsSameSizeHeight
        }
        return liHeightAuto
      },
      set(val) {
        this.$changeOptionsEV(val, "liIsSameSizeHeight", false)
      }
    },
    liWidth: {
      get() {
        return this.options.liWidth
      },
      set(val) {
        this.$changeOptionsEV(val, "liWidth", false)
      }
    },
    liHeight: {
      get() {
        console.log("liHeight===", this.options.liHeight)
        return this.options.liHeight
      },
      set(val) {
        this.$changeOptionsEV(val, "liHeight", false)
      }
    },
    showPlaceHolderText: {
      get() {
        return this.options.showPlaceHolderText
      },
      set(val) {
        this.$changeOptionsEV(val, "showPlaceHolderText", false)
      }
    },
    placeholderText: {
      get() {
        return this.options.placeholderText
      },
      set(val) {
        this.$changeOptionsEV(val, "placeholderText", false)
      }
    },
    selectFontFamily: {
      get() {
        return this.options.selectFontFamily
      },
      set(val) {
        this.$changeOptionsEV(val, "selectFontFamily", false)
      }
    },
    selectFontSize: {
      get() {
        return this.options.selectFontSize
      },
      set(val) {
        this.$changeOptionsEV(val, "selectFontSize", false)
      }
    },
    selectFontWeight: {
      get() {
        return this.options.selectFontWeight
      },
      set(val) {
        this.$changeOptionsEV(val, "selectFontWeight", false)
      }
    },
    selectFontColor: {
      get() {
        return this.options.selectFontColor
      },
      set(val) {
        this.$changeOptionsEV(val, "selectFontColor", false)
      }
    },
    selectBgColor: {
      get() {
        return this.options.selectBgColor
      },
      set(val) {
        this.$changeOptionsEV(val, "selectBgColor", false)
      }
    },
    selectBgIsThemeColor: {
      get() {
        return this.options.selectBgIsThemeColor
      },
      set(val) {
        this.$changeOptionsEV(val, "selectBgIsThemeColor", false)
      }
    },
    selectBoxShadowColor: {
      get() {
        return this.options.selectBoxShadowColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "selectBoxShadowColor", false)
      }
    },
    selectBoxShadowH: {
      get() {
        return this.options.selectBoxShadowH
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "selectBoxShadowH", false)
      }
    },
    selectBoxShadowV: {
      get() {
        return this.options.selectBoxShadowV
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "selectBoxShadowV", false)
      }
    },
    selectBoxShadowBlur: {
      get() {
        return this.options.selectBoxShadowBlur
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "selectBoxShadowBlur", false)
      }
    },
    selectBoxShadowSpread: {
      get() {
        return this.options.selectBoxShadowSpread
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "selectBoxShadowSpread", false)
      }
    },
    showLiBorder: {
      get() {
        let showLiBorder = false
        if (this.options.showLiBorder === undefined) {
          if (this.options.liBorderWidth) {
            showLiBorder = true
          } else {
            showLiBorder = false
          }
        } else {
          showLiBorder = this.options.showLiBorder
        }
        return showLiBorder
      },
      set(newVal) {
        if(newVal && !this.liBorderWidth) {
          this.$changeOptionsEV([1, newVal], ["liBorderWidth", "showLiBorder"], false)
        } else {
          this.$changeOptionsEV(newVal, "showLiBorder", false)
        }
      }
    },
    liBorderColor: {
      get() {
        return this.options.liBorderColor
      },
      set(val) {
        this.$changeOptionsEV(val, "liBorderColor", false)
      }
    },
    liBorderWidth: {
      get() {
        return this.options.liBorderWidth
      },
      set(val) {
        this.$changeOptionsEV(val, "liBorderWidth", false)
      }
    },
    liBorderStyle: {
      get() {
        return this.options.liBorderStyle
      },
      set(val) {
        this.$changeOptionsEV(val, "liBorderStyle", false)
      }
    },
    liBorderIsThemeColor: {
      get() {
        return this.options.liBorderIsThemeColor
      },
      set(val) {
        this.$changeOptionsEV(val, "liBorderIsThemeColor", false)
      }
    },
    clearLiLastBorder: {
      get() {
        return this.options.clearLiLastBorder
      },
      set(val) {
        this.$changeOptionsEV(val, "clearLiLastBorder", false)
      }
    },
    borderTypeFlag: {
      get() {
        let defaultType = 1
        if (!this.options.hasOwnProperty("borderTypeFlag")) {
          if (
            ((this.borderTopLeftRadius === this.borderTopRightRadius) === this.borderBottomLeftRadius) ===
            this.borderBottomRightRadius
          ) {
            defaultType = 2
          }
        }
        // return this.checkAndSetPrimaryVal(this.options, "borderTypeFlag", "borderTypeFlag", defaultType)
        // 上面方法貌似是执行需要一定的时间，造成最开始还未写入值，进行点击 会出现问题
        return this.options.borderTypeFlag || defaultType
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderTypeFlag", false)
      }
    },
    borderRadius: {
      get() {
        return Number(this.options.borderBottomLeftRadius)
      },
      set(newVal) {
        this.$changeOptionsEV(
          [newVal, newVal, newVal, newVal],
          ["borderTopLeftRadius", "borderTopRightRadius", "borderBottomRightRadius", "borderBottomLeftRadius"],
          false
        )
      }
    },
    borderTopLeftRadius: {
      get() {
        return Number(this.options.borderTopLeftRadius)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderTopLeftRadius", false)
      }
    },
    borderTopRightRadius: {
      get() {
        return Number(this.options.borderTopRightRadius)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderTopRightRadius", false)
      }
    },
    borderBottomRightRadius: {
      get() {
        return Number(this.options.borderBottomRightRadius)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderBottomRightRadius", false)
      }
    },
    borderBottomLeftRadius: {
      get() {
        return Number(this.options.borderBottomLeftRadius)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderBottomLeftRadius", false)
      }
    },
    liActiveArrangement() {
      return this.options.liTextAlign
    },
    liActiveArrangementOrder: {
      get() {
        return {
          _class: "icon-portal-text-down1",
          isActive: this.options.liWritingMode === "vertical-lr" ? true : false
        }
      },
      set(newVal) {
        let val = newVal ? "vertical-lr" : "horizontal-tb"
        this.$changeOptionsEV(val, "liWritingMode", false)
      }
    },
    liLetterSpacing: {
      get() {
        return this.options.liLetterSpacing
      },
      set(newVal) {
        this.$changeOptionsEV(`${newVal}`, "liLetterSpacing", false)
      }
    },
    liLineHeight: {
      get() {
        return this.options.liLineHeight
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liLineHeight", false)
      }
    },
    liLineHeightType: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "liLineHeightType", "liLineHeightType", "px")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liLineHeightType", false)
      }
    },
    liIsThemeColor: {
      get() {
        return this.options.liIsThemeColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liIsThemeColor", false)
      }
    },
    liFontStyle: {
      get() {
        return this.options.liFontStyle
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liFontStyle", false)
      }
    },
    liTextAlign: {
      get() {
        return this.options.liTextAlign
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liTextAlign", false)
      }
    },
    liTextIsThemeColor: {
      get() {
        return this.options.liTextIsThemeColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liTextIsThemeColor", false)
      }
    },
    liWritingMode: {
      get() {
        return this.options.liWritingMode
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liWritingMode", false)
      }
    },
    liTextDecoration: {
      get() {
        return this.options.liTextDecoration
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liTextDecoration", false)
      }
    },
    liFontFamily: {
      get() {
        return this.options.liFontFamily
      },
      set(val) {
        this.$changeOptionsEV(val, "liFontFamily", false)
      }
    },
    liFontSize: {
      get() {
        return this.options.liFontSize
      },
      set(val) {
        this.$changeOptionsEV(val, "liFontSize", false)
      }
    },
    liFontWeight: {
      get() {
        return this.options.liFontWeight
      },
      set(val) {
        this.$changeOptionsEV(val, "liFontWeight", false)
      }
    },
    liFontColor: {
      get() {
        return this.options.liFontColor
      },
      set(val) {
        this.$changeOptionsEV(val, "liFontColor", false)
      }
    },
    liVerticalAlign: {
      get() {
        return this.options.liVerticalAlign || "top"
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liVerticalAlign", false)
      }
    },
    liTextLimitCount: {
      get() {
        return this.options.liTextLimitCount
      },
      set(val) {
        this.$changeOptionsEV(val, "liTextLimitCount", false)
      }
    },
    liTextLimit: {
      get() {
        return this.options.liTextLimit === undefined ? false : this.options.liTextLimit
      },
      set(val) {
        this.$changeOptionsEV(val, "liTextLimit", false)
      }
    },
    boxShadowColor: {
      get() {
        return this.options.boxShadowColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "boxShadowColor", false)
      }
    },
    boxShadowH: {
      get() {
        return this.options.boxShadowH
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "boxShadowH", false)
      }
    },
    boxShadowV: {
      get() {
        return this.options.boxShadowV
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "boxShadowV", false)
      }
    },
    boxShadowBlur: {
      get() {
        return this.options.boxShadowBlur
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "boxShadowBlur", false)
      }
    },
    boxShadowSpread: {
      get() {
        return this.options.boxShadowSpread
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "boxShadowSpread", false)
      }
    },
    widthAuto: {
      get() {
        return this.options.widthAuto
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "widthAuto", false)
      }
    },
    heightAuto: {
      get() {
        return this.options.heightAuto
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "heightAuto", false)
      }
    },
    navWidth: {
      get() {
        return this.options.navWidth
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "navWidth", false)
      }
    },
    navHeight: {
      get() {
        return this.options.navHeight
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "navHeight", false)
      }
    },
    navMargin: {
      get() {
        return this.options.navMargin
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "navMargin", false)
      }
    },
    activeBgColor: {
      get() {
        let background = this.options.activeBgColor
        if (background && Array.isArray(background) && background.length > 0) {
          return this.options.activeBgColor
        }
        let newBackground = [
          {
            type: "color",
            label: "颜色",
            isThemeColor: false,
            color:
              this.options.activeBgColor && this.options.activeBgColor.color
                ? this.options.activeBgColor.color
                : this.options.activeBgColor
          }
        ]
        this.$changeOptionsEV(newBackground, "activeBgColor", false, false, false, true)
        return newBackground
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activeBgColor", false)
      }
    },
    activeBgIsThemeColor: {
      get() {
        return this.options.activeBgIsThemeColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activeBgIsThemeColor", false)
      }
    },
    showTopNavActiveBorder: {
      get() {
        let showTopNavActiveBorder = false
        if (this.options.showTopNavActiveBorder === undefined) {
          if (Array.isArray(this.options.activeBorderWidth)) {
            let allZero = true
            for (let i = 0; i < this.options.activeBorderWidth.length; i++) {
              if (this.options.activeBorderWidth[i] !== 0) {
                allZero = false
              }
            }
            if (allZero) {
              showTopNavActiveBorder = false
            } else {
              showTopNavActiveBorder = true
            }
          } else {
            if (this.options.activeBorderWidth) {
              showTopNavActiveBorder = true
            } else {
              showTopNavActiveBorder = false
            }
          }
        } else {
          showTopNavActiveBorder = this.options.showTopNavActiveBorder
        }
        return showTopNavActiveBorder
      },
      set(newVal) {
        if(newVal && !this.activeBorderWidth) {
          this.$changeOptionsEV([1, newVal], ["activeBorderWidth", "showTopNavActiveBorder"], false)
        } else {
          this.$changeOptionsEV(newVal, "showTopNavActiveBorder", false)
        }
      }
    },
    activeBorderWidth: {
      get() {
        return this.options.activeBorderWidth
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activeBorderWidth", false)
      }
    },
    activeBorderColor: {
      get() {
        return this.options.activeBorderColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activeBorderColor", false)
      }
    },
    activeBorderStyle: {
      get() {
        return this.options.activeBorderStyle
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activeBorderStyle", false)
      }
    },
    activeBorderIsThemeColor: {
      get() {
        return this.options.activeBorderIsThemeColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activeBorderIsThemeColor", false)
      }
    },
    activeActiveArrangement() {
      return this.options.activeTextAlign
    },
    activeActiveArrangementOrder: {
      get() {
        return {
          _class: "icon-portal-text-down1",
          isActive: this.options.liWritingMode === "vertical-lr" ? true : false
        }
      },
      set(newVal) {
        let val = newVal ? "vertical-lr" : "horizontal-tb"
        this.$changeOptionsEV(val, "liWritingMode", false)
      }
    },
    activeLetterSpacing: {
      get() {
        return this.options.activeLetterSpacing
      },
      set(newVal) {
        this.$changeOptionsEV(`${newVal}`, "activeLetterSpacing", false)
      }
    },
    activeLineHeight: {
      get() {
        return this.options.activeLineHeight
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activeLineHeight", false)
      }
    },
    activeLineHeightType:{
      get() {
        return this.checkAndSetPrimaryVal(this.options, "activeLineHeightType", "activeLineHeightType", "px")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activeLineHeightType", false)
        /**/
      }
    },
    activeFontStyle: {
      get() {
        return this.options.activeFontStyle
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activeFontStyle", false)
      }
    },
    activeTextAlign: {
      get() {
        return this.options.activeTextAlign
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activeTextAlign", false)
      }
    },
    activeTextIsThemeColor: {
      get() {
        return this.options.activeTextIsThemeColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activeTextIsThemeColor", false)
      }
    },
    activeWritingMode: {
      get() {
        return this.options.activeWritingMode
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activeWritingMode", false)
      }
    },
    activeTextDecoration: {
      get() {
        return this.options.activeTextDecoration
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activeTextDecoration", false)
      }
    },
    activeFontFamily: {
      get() {
        return this.options.activeFontFamily
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activeFontFamily", false)
      }
    },
    activeFontSize: {
      get() {
        return this.options.activeFontSize
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activeFontSize", false)
      }
    },
    activeFontWeight: {
      get() {
        return this.options.activeFontWeight
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activeFontWeight", false)
      }
    },
    activeVerticalAlign: {
      get() {
        return this.options.activeVerticalAlign || "top"
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activeVerticalAlign", false)
      }
    },
    activeFontColor: {
      get() {
        return this.options.activeFontColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activeFontColor", false)
      }
    },
    topNavActiveTextLimitCount: {
      get() {
        return this.options.topNavActiveTextLimitCount
      },
      set(val) {
        this.$changeOptionsEV(val, "topNavActiveTextLimitCount", false)
      }
    },
    topNavActiveTextLimit: {
      get() {
        return this.options.topNavActiveTextLimit
      },
      set(val) {
        this.$changeOptionsEV(val, "topNavActiveTextLimit", false)
      }
    },
    topNavActiveBorderTypeFlag: {
      get() {
        let defaultType = 1
        if (!this.options.hasOwnProperty("topNavActiveBorderTypeFlag")) {
          if (
            ((this.topNavActiveBorderTopLeftRadius === this.topNavActiveBorderTopRightRadius) ===
              this.topNavActiveBorderBottomRightRadius) ===
            this.topNavActiveBorderBottomLeftRadius
          ) {
            defaultType = 2
          }
        }
        return this.options.topNavActiveBorderTypeFlag || defaultType
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "topNavActiveBorderTypeFlag", false)
      }
    },
    topNavActiveBorderRadius: {
      get() {
        return Number(this.options.topNavActiveBorderRadius) || 0
      },
      set(newVal) {
        this.$changeOptionsEV(
          [newVal, newVal, newVal, newVal, newVal],
          [
            "topNavActiveBorderRadius",
            "topNavActiveBorderTopLeftRadius",
            "topNavActiveBorderTopRightRadius",
            "topNavActiveBorderBottomRightRadius",
            "topNavActiveBorderBottomLeftRadius"
          ],
          false
        )
      }
    },
    topNavActiveBorderTopLeftRadius: {
      get() {
        return Number(this.options.topNavActiveBorderTopLeftRadius) || 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "topNavActiveBorderTopLeftRadius", false)
      }
    },
    topNavActiveBorderTopRightRadius: {
      get() {
        return Number(this.options.topNavActiveBorderTopRightRadius) || 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "topNavActiveBorderTopRightRadius", false)
      }
    },
    topNavActiveBorderBottomRightRadius: {
      get() {
        return Number(this.options.topNavActiveBorderBottomRightRadius) || 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "topNavActiveBorderBottomRightRadius", false)
      }
    },
    topNavActiveBorderBottomLeftRadius: {
      get() {
        return Number(this.options.topNavActiveBorderBottomLeftRadius) || 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "topNavActiveBorderBottomLeftRadius", false)
      }
    },
    hoverBgColor: {
      get() {
        let background = this.options.hoverBgColor
        if (background && Array.isArray(background) && background.length > 0) {
          return this.options.hoverBgColor
        }
        let newBackground = [
          {
            type: "color",
            label: "颜色",
            isThemeColor: false,
            color:
              this.options.hoverBgColor && this.options.hoverBgColor.color
                ? this.options.hoverBgColor.color
                : this.options.hoverBgColor
          }
        ]
        this.$changeOptionsEV(newBackground, "hoverBgColor", false, false, false, true)
        return newBackground
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hoverBgColor", false)
      }
    },
    hoverBgIsThemeColor: {
      get() {
        return this.options.hoverBgIsThemeColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hoverBgIsThemeColor", false)
      }
    },
    showTopNavHoverBorder: {
      get() {
        let showTopNavHoverBorder = false
        if (this.options.showTopNavHoverBorder === undefined) {
          if (this.options.hoverBorderWidth) {
            showTopNavHoverBorder = true
          } else {
            showTopNavHoverBorder = false
          }
        } else {
          showTopNavHoverBorder = this.options.showTopNavHoverBorder
        }
        return showTopNavHoverBorder
      },
      set(newVal) {
        if(newVal && !this.hoverBorderWidth) {
          this.$changeOptionsEV([1, newVal], ["hoverBorderWidth", "showTopNavHoverBorder"], false)
        } else {
          this.$changeOptionsEV(newVal, "showTopNavHoverBorder", false)
        }
      }
    },
    hoverBorderWidth: {
      get() {
        return this.options.hoverBorderWidth
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hoverBorderWidth", false)
      }
    },
    hoverBorderColor: {
      get() {
        return this.options.hoverBorderColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hoverBorderColor", false)
      }
    },
    hoverBorderStyle: {
      get() {
        return this.options.hoverBorderStyle
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hoverBorderStyle", false)
      }
    },
    hoverBorderIsThemeColor: {
      get() {
        return this.options.hoverBorderIsThemeColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hoverBorderIsThemeColor", false)
      }
    },
    hoverActiveArrangement() {
      return this.options.hoverTextAlign
    },
    hoverActiveArrangementOrder: {
      get() {
        return {
          _class: "icon-portal-text-down1",
          isActive: this.options.liWritingMode === "vertical-lr" ? true : false
        }
      },
      set(newVal) {
        let val = newVal ? "vertical-lr" : "horizontal-tb"
        this.$changeOptionsEV(val, "hoverWritingMode", false)
      }
    },
    hoverLetterSpacing: {
      get() {
        return this.options.hoverLetterSpacing
      },
      set(newVal) {
        this.$changeOptionsEV(`${newVal}`, "hoverLetterSpacing", false)
      }
    },
    hoverLineHeight: {
      get() {
        return this.options.hoverLineHeight
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hoverLineHeight", false)
      }
    },
    hoverLineHeightType:{
      get() {
        return this.checkAndSetPrimaryVal(this.options, "hoverLineHeightType", "hoverLineHeightType", "px")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hoverLineHeightType", false)
        /**/
      }
    },
    hoverFontStyle: {
      get() {
        return this.options.hoverFontStyle
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hoverFontStyle", false)
      }
    },
    hoverTextAlign: {
      get() {
        return this.options.hoverTextAlign
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hoverTextAlign", false)
      }
    },
    hoverTextIsThemeColor: {
      get() {
        return this.options.hoverTextIsThemeColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hoverTextIsThemeColor", false)
      }
    },
    hoverWritingMode: {
      get() {
        return this.options.hoverWritingMode
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hoverWritingMode", false)
      }
    },
    hoverTextDecoration: {
      get() {
        return this.options.hoverTextDecoration
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hoverTextDecoration", false)
      }
    },
    hoverFontFamily: {
      get() {
        return this.options.hoverFontFamily
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hoverFontFamily", false)
      }
    },
    hoverFontSize: {
      get() {
        return this.options.hoverFontSize
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hoverFontSize", false)
      }
    },
    hoverFontWeight: {
      get() {
        return this.options.hoverFontWeight
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hoverFontWeight", false)
      }
    },
    hoverVerticalAlign: {
      get() {
        return this.options.hoverVerticalAlign || "top"
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hoverVerticalAlign", false)
      }
    },
    hoverFontColor: {
      get() {
        return this.options.hoverFontColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hoverFontColor", false)
      }
    },
    hoverTextLimitCount: {
      get() {
        return this.options.hoverTextLimitCount
      },
      set(val) {
        this.$changeOptionsEV(val, "hoverTextLimitCount", false)
      }
    },
    hoverTextLimit: {
      get() {
        return this.options.hoverTextLimit
      },
      set(val) {
        this.$changeOptionsEV(val, "hoverTextLimit", false)
      }
    },
    hoverIsSameActive: {
      get() {
        return this.options.hoverIsSameActive
      },
      set(newVal) {
        if(!newVal){
          // 取消同步选中状态时，需要将当前的激活属性的值同步给悬浮属性
          this.activeValueToHover()
        }
        this.$changeOptionsEV(newVal, "hoverIsSameActive", false)
      }
    },
    topNavHoverBorderTypeFlag: {
      get() {
        let defaultType = 1
        if (!this.options.hasOwnProperty("topNavHoverBorderTypeFlag")) {
          if (
            ((this.topNavHoverBorderTopLeftRadius === this.topNavHoverBorderTopRightRadius) ===
              this.topNavHoverBorderBottomRightRadius) ===
            this.topNavHoverBorderBottomLeftRadius
          ) {
            defaultType = 2
          }
        }
        return this.options.topNavHoverBorderTypeFlag || defaultType
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "topNavHoverBorderTypeFlag", false)
      }
    },
    topNavHoverBorderRadius: {
      get() {
        return Number(this.options.topNavHoverBorderRadius) || 0
      },
      set(newVal) {
        this.$changeOptionsEV(
          [newVal, newVal, newVal, newVal, newVal],
          [
            "topNavHoverBorderRadius",
            "topNavHoverBorderTopLeftRadius",
            "topNavHoverBorderTopRightRadius",
            "topNavHoverBorderBottomRightRadius",
            "topNavHoverBorderBottomLeftRadius"
          ],
          false
        )
      }
    },
    topNavHoverBorderTopLeftRadius: {
      get() {
        return Number(this.options.topNavHoverBorderTopLeftRadius) || 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "topNavHoverBorderTopLeftRadius", false)
      }
    },
    topNavHoverBorderTopRightRadius: {
      get() {
        return Number(this.options.topNavHoverBorderTopRightRadius) || 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "topNavHoverBorderTopRightRadius", false)
      }
    },
    topNavHoverBorderBottomRightRadius: {
      get() {
        return Number(this.options.topNavHoverBorderBottomRightRadius) || 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "topNavHoverBorderBottomRightRadius", false)
      }
    },
    topNavHoverBorderBottomLeftRadius: {
      get() {
        return Number(this.options.topNavHoverBorderBottomLeftRadius) || 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "topNavHoverBorderBottomLeftRadius", false)
      }
    },
    liHoverBgColor: {
      get() {
        if(Array.isArray(this.options.liHoverBgColor)){
          return this.options.liHoverBgColor
        }else if(this.options.liHoverBgColor){
          let bgArr = [{
            ...this.options.liHoverBgColor,
            isThemeColor: this.options.liHoverBgIsThemeColor
          }]
          this.$changeOptionsEV(bgArr, "liHoverBgColor", false)
          return  bgArr
        }else {
          let bgArr = [{
              type: "color",
              label: "颜色",
              color: "rgba(255,255,255,1)",
              data:{
                "stops": [
                [
                  "rgba(255,255,255,1)", 0
                ],
                [
                  "rgba(255,255,255,1)", 1
                ]
              ],
              "angle": 0
            },
             isThemeColor: this.options.liHoverBgIsThemeColor
          }]
          this.$changeOptionsEV(bgArr, "liHoverBgColor", false)
          return  bgArr
        }
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liHoverBgColor", false)
      }
    },
    liHoverBgIsThemeColor: {
      get() {
        return this.options.liHoverBgIsThemeColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liHoverBgIsThemeColor", false)
      }
    },
    showLiHoverBorder: {
      get() {
        let showLiHoverBorder = false
        if (this.options.showLiHoverBorder === undefined) {
          if (this.options.liHoverBorderWidth) {
            showLiHoverBorder = true
          } else {
            showLiHoverBorder = false
          }
        } else {
          showLiHoverBorder = this.options.showLiHoverBorder
        }
        return showLiHoverBorder
      },
      set(newVal) {
        if(newVal && !this.liHoverBorderWidth) {
          this.$changeOptionsEV([1, newVal], ["liHoverBorderWidth", "showLiHoverBorder"], false)
        } else {
          this.$changeOptionsEV(newVal, "showLiHoverBorder", false)
        }
      }
    },
    liHoverBorderWidth: {
      get() {
        return this.options.liHoverBorderWidth
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liHoverBorderWidth", false)
      }
    },
    liHoverBorderColor: {
      get() {
        return this.options.liHoverBorderColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liHoverBorderColor", false)
      }
    },
    liHoverBorderStyle: {
      get() {
        return this.options.liHoverBorderStyle
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liHoverBorderStyle", false)
      }
    },
    liHoverBorderIsThemeColor: {
      get() {
        return this.options.liHoverBorderIsThemeColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liHoverBorderIsThemeColor", false)
      }
    },
    clearLiLastHoverBorder: {
      get() {
        return this.options.clearLiLastHoverBorder || false
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "clearLiLastHoverBorder", false)
      }
    },
    liHoverBorderTypeFlag: {
      get() {
        let defaultType = 1
        if (!this.options.hasOwnProperty("liHoverBorderTypeFlag")) {
          if (
            ((this.liHoverBorderTopLeftRadius === this.liHoverBorderTopRightRadius) ===
              this.liHoverBorderBottomRightRadius) ===
            this.liHoverBorderBottomLeftRadius
          ) {
            defaultType = 2
          }
        }
        return this.options.liHoverBorderTypeFlag || defaultType
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liHoverBorderTypeFlag", false)
      }
    },
    liHoverBorderRadius: {
      get() {
        return Number(this.options.liHoverBorderRadius) || 0
      },
      set(newVal) {
        this.$changeOptionsEV(
          [newVal, newVal, newVal, newVal, newVal],
          [
            "liHoverBorderRadius",
            "liHoverBorderTopLeftRadius",
            "liHoverBorderTopRightRadius",
            "liHoverBorderBottomRightRadius",
            "liHoverBorderBottomLeftRadius"
          ],
          false
        )
      }
    },
    liHoverBorderTopLeftRadius: {
      get() {
        return Number(this.options.liHoverBorderTopLeftRadius) || 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liHoverBorderTopLeftRadius", false)
      }
    },
    liHoverBorderTopRightRadius: {
      get() {
        return Number(this.options.liHoverBorderTopRightRadius) || 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liHoverBorderTopRightRadius", false)
      }
    },
    liHoverBorderBottomRightRadius: {
      get() {
        return Number(this.options.liHoverBorderBottomRightRadius) || 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liHoverBorderBottomRightRadius", false)
      }
    },
    liHoverBorderBottomLeftRadius: {
      get() {
        return Number(this.options.liHoverBorderBottomLeftRadius) || 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liHoverBorderBottomLeftRadius", false)
      }
    },
    liHoverActiveArrangement() {
      return this.options.liHoverTextAlign
    },
    liHoverActiveArrangementOrder: {
      get() {
        return {
          _class: "icon-portal-text-down1",
          isActive: this.options.liWritingMode === "vertical-lr" ? true : false
        }
      },
      set(newVal) {
        let val = newVal ? "vertical-lr" : "horizontal-tb"
        this.$changeOptionsEV(val, "liHoverWritingMode", false)
      }
    },
    liHoverLetterSpacing: {
      get() {
        return this.options.liHoverLetterSpacing
      },
      set(newVal) {
        this.$changeOptionsEV(`${newVal}`, "liHoverLetterSpacing", false)
      }
    },
    liHoverLineHeight: {
      get() {
        return this.options.liHoverLineHeight
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liHoverLineHeight", false)
      }
    },
    liHoverLineHeightType: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "liHoverLineHeightType", "liHoverLineHeightType", 'px')
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liHoverLineHeightType", false)
      }
    },
    liHoverFontStyle: {
      get() {
        return this.options.liHoverFontStyle
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liHoverFontStyle", false)
      }
    },
    liHoverTextAlign: {
      get() {
        return this.options.liHoverTextAlign
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liHoverTextAlign", false)
      }
    },
    liHoverVerticalAlign: {
      get() {
        return this.options.liHoverVerticalAlign || "top"
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liHoverVerticalAlign", false)
      }
    },
    liHoverTextIsThemeColor: {
      get() {
        return this.options.liHoverTextIsThemeColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liHoverTextIsThemeColor", false)
      }
    },
    liHoverWritingMode: {
      get() {
        return this.options.liHoverWritingMode
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liHoverWritingMode", false)
      }
    },
    liHoverTextDecoration: {
      get() {
        return this.options.liHoverTextDecoration
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liHoverTextDecoration", false)
      }
    },
    liHoverFontFamily: {
      get() {
        return this.options.liHoverFontFamily
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liHoverFontFamily", false)
      }
    },
    liHoverFontSize: {
      get() {
        return this.options.liHoverFontSize
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liHoverFontSize", false)
      }
    },
    liHoverFontWeight: {
      get() {
        return this.options.liHoverFontWeight
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liHoverFontWeight", false)
      }
    },
    liHoverFontColor: {
      get() {
        return this.options.liHoverFontColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liHoverFontColor", false)
      }
    },
    liHoverIsSameActive: {
      get() {
        return this.options.liHoverIsSameActive
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liHoverIsSameActive", false)
      }
    },
    liHoverTextLimitCount: {
      get() {
        return this.options.liHoverTextLimitCount
      },
      set(val) {
        this.$changeOptionsEV(val, "liHoverTextLimitCount", false)
      }
    },
    liHoverTextLimit: {
      get() {
        return this.options.liHoverTextLimit
      },
      set(val) {
        this.$changeOptionsEV(val, "liHoverTextLimit", false)
      }
    },
    ulBgIsThemeColor: {
      get() {
        return this.options.ulBgIsThemeColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "ulBgIsThemeColor", false)
      }
    },
    ulBgColor: {
      get() {
        if(Array.isArray(this.options.ulBgColor)){
          return this.options.ulBgColor
        }else if(typeof this.options.ulBgColor === 'string' && (this.options.ulBgColor.indexOf("#") !== -1 || this.options.ulBgColor.indexOf("rgb") !== -1)){
          let bgArr = [{
            // ...this.options.ulBgColor,
            // ulBgColor为字符串类型时
            type: "color",
            label: "颜色",
            color: this.options.ulBgColor,
            data:{
              "stops": [
                [this.options.ulBgColor, 0],
                [this.options.ulBgColor, 1]
              ],
              "angle": 0
            },
            isThemeColor: this.options.ulBgIsThemeColor || false
          }]
          this.$changeOptionsEV(bgArr, "ulBgColor", false)
          return bgArr
        }else{
          let bgArr = [{
            type: "color",
            label: "颜色",
            color: "rgba(255,255,255,1)",
            data:{
              "stops": [
                [
                  "rgba(255,255,255,1)", 0
                ],
                [
                  "rgba(255,255,255,1)", 1
                ]
              ],
              "angle": 0
            },
            isThemeColor: this.options.ulBgIsThemeColor || false
          }]
          this.$changeOptionsEV(bgArr, "ulBgColor", false)
          return bgArr
        }
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "ulBgColor", false)
      }
    },
    resInfo: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "resInfo", "resInfo", {})
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "resInfo", false)
      }
    },
    isWrap: {
      get() {
        return this.options.hasOwnProperty("isWrap") ? this.options.isWrap : true
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "isWrap", false)
      }
    },
    navMarginBottom: {
      get() {
        return this.options.navMarginBottom || 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "navMarginBottom", false)
      }
    },
    padding: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "padding", "padding", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "padding", false)
      }
    },
    topPaddingTypeFlag: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "topPaddingTypeFlag", "topPaddingTypeFlag", 1)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "topPaddingTypeFlag", false)
      }
    },
    paddingTop: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "paddingTop", "paddingTop", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "paddingTop", false)
      }
    },
    paddingRight: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "paddingRight", "paddingRight", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "paddingRight", false)
      }
    },
    paddingLeft: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "paddingLeft", "paddingLeft", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "paddingLeft", false)
      }
    },
    paddingBottom: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "paddingBottom", "paddingBottom", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "paddingBottom", false)
      }
    },
    liIconPosition: {
      get() {
        return this.options.liIconPosition === undefined ? this.options.iconPosition : this.options.liIconPosition
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liIconPosition", false)
      }
    },
    showLiIcon: {
      get() {
        // 兼容旧数据
        let hasIconSic = false
        if (this.options.showLiIcon === undefined) {
          if (this.options.iconSrc.length > 0) {
            hasIconSic = true
          } else {
            hasIconSic = false
            this.$changeOptionsEV("right", "liIconPosition", false, false, false, true)
          }
        } else {
          hasIconSic = this.options.showLiIcon
        }
        return hasIconSic
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "showLiIcon", false)
      }
    },
    liIconSrc: {
      get() {
        return this.options.liIconSrc === undefined ? this.options.iconSrc : this.options.liIconSrc
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liIconSrc", false)
      }
    },
    liIconType: {
      get() {
        return this.options.liIconType || "icon"
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liIconType", false)
      }
    },
    liIconWidth: {
      get() {
        return this.options.liIconWidth === undefined ? this.options.iconWidth : this.options.liIconWidth
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liIconWidth", false)
      }
    },
    liIconMargin: {
      get() {
        return this.options.liIconMargin === undefined ? this.options.iconMargin : this.options.liIconMargin
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liIconMargin", false)
      }
    },
    liIconColor: {
      get() {
        return this.options.liIconColor === undefined ? this.options.iconColor : this.options.liIconColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liIconColor", false)
      }
    },
    liIconColorIsThemeColor: {
      get() {
        return this.options.liIconColorIsThemeColor || false
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liIconColorIsThemeColor", false)
      }
    },
    liResInfo: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "liResInfo", "liResInfo", {})
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liResInfo", false)
      }
    },
    liBorderTypeFlag: {
      get() {
        let defaultType = 1
        if (!this.options.hasOwnProperty("liBorderTypeFlag")) {
          if (
            ((this.liBorderTopLeftRadius === this.liBorderTopRightRadius) === this.liBorderBottomRightRadius) ===
            this.liBorderBottomLeftRadius
          ) {
            defaultType = 2
          }
        }
        return this.options.liBorderTypeFlag || defaultType
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liBorderTypeFlag", false)
      }
    },
    liBorderRadius: {
      get() {
        return Number(this.options.liBorderRadius) || 0
      },
      set(newVal) {
        this.$changeOptionsEV(
          [newVal, newVal, newVal, newVal, newVal],
          [
            "liBorderRadius",
            "liBorderTopLeftRadius",
            "liBorderTopRightRadius",
            "liBorderBottomRightRadius",
            "liBorderBottomLeftRadius"
          ],
          false
        )
      }
    },
    liBorderTopLeftRadius: {
      get() {
        return Number(this.options.liBorderTopLeftRadius) || 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liBorderTopLeftRadius", false)
      }
    },
    liBorderTopRightRadius: {
      get() {
        return Number(this.options.liBorderTopRightRadius) || 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liBorderTopRightRadius", false)
      }
    },
    liBorderBottomRightRadius: {
      get() {
        return Number(this.options.liBorderBottomRightRadius) || 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liBorderBottomRightRadius", false)
      }
    },
    liBorderBottomLeftRadius: {
      get() {
        return Number(this.options.liBorderBottomLeftRadius) || 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liBorderBottomLeftRadius", false)
      }
    },
    liPaddingTypeFlag: {
      get() {
        let defaultType = 1
        if (!this.options.hasOwnProperty("liPaddingTypeFlag") || this.options.liPaddingTypeFlag === undefined) {
          if (
            ((this.topNavPaddingTop === this.topNavPaddingRight) === this.topNavPaddingLeft) ===
            this.topNavPaddingBottom
          ) {
            defaultType = 2
          }
          if (this.options.liPaddingTypeFlag === undefined) {
            defaultType = 2
          }
        } else {
          defaultType = this.options.liPaddingTypeFlag
        }
        return this.checkAndSetPrimaryVal(this.options, "liPaddingTypeFlag", "liPaddingTypeFlag", defaultType)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liPaddingTypeFlag", false)
      }
    },
    liPadding: {
      get() {
        return this.options.liPadding !== undefined ? this.options.liPadding : 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liPadding", false)
      }
    },
    liPaddingTop: {
      get() {
        return this.options.liPaddingTop !== undefined ? this.options.liPaddingTop : 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liPaddingTop", false)
      }
    },
    liPaddingRight: {
      get() {
        return this.options.liPaddingRight !== undefined ? this.options.liPaddingRight : 10
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liPaddingRight", false)
      }
    },
    liPaddingLeft: {
      get() {
        return this.options.liPaddingLeft !== undefined ? this.options.liPaddingLeft : 10
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liPaddingLeft", false)
      }
    },
    liPaddingBottom: {
      get() {
        return this.options.liPaddingBottom !== undefined ? this.options.liPaddingBottom : 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liPaddingBottom", false)
      }
    },
    liOpacity: {
      get() {
        return this.options.liOpacity
      },
      set(val) {
        this.$changeOptionsEV(val, "liOpacity", false)
      }
    },
    liRotate: {
      get() {
        return this.options.liRotate || 0
      },
      set(val) {
        this.$changeOptionsEV(val, "liRotate", false)
      }
    },
    liMargin: {
      get() {
        return this.options.liMargin || 0
      },
      set(val) {
        this.$changeOptionsEV(val, "liMargin", false)
      }
    },
    //   列表
    ulWidthAuto: {
      get() {
        return this.options.ulWidthAuto
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "ulWidthAuto", false)
      }
    },
    ulHeightAuto: {
      get() {
        return this.options.ulHeightAuto
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "ulHeightAuto", false)
      }
    },
    ulWidth: {
      get() {
        return this.options.ulWidth
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "ulWidth", false)
      }
    },
    ulHeight: {
      get() {
        return this.options.ulHeight
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "ulHeight", false)
      }
    },
    ulBackground: {
      get() {
        let background = this.options.ulBackground
        if (background && Array.isArray(background) && background.length > 0) {
          return this.options.ulBackground
        }
        let newBackground = [
          {
            type: "color",
            label: "颜色",
            isThemeColor: false,
            color: this.options.ulBgColor
          }
        ]
        let color1 = this.options.ulBgColor
        if (color1 && typeof this.options.ulBgColor === "object" && color1.color) {
          color1 = this.options.ulBgColor.color
          newBackground = [
            {
              type: "color",
              label: "颜色",
              isThemeColor: false,
              color: this.options.ulBgColor.color
            }
          ]
        } else if (color1 && Array.isArray(color1) && color1.length > 0) {
          newBackground = this.options.ulBgColor
        }

        this.$changeOptionsEV(newBackground, "ulBackground", false, false, false, true)
        return newBackground
      },
      set(val) {
        this.$changeOptionsEV(val, "ulBackground", false)
      }
    },
    showUlBorder: {
      get() {
        let showUlBorder = false
        if (this.options.showUlBorder === undefined) {
          if (this.options.ulBorderWidth) {
            showUlBorder = true
          } else {
            showUlBorder = false
          }
        } else {
          showUlBorder = this.options.showUlBorder
        }
        return showUlBorder
      },
      set(newVal) {
        if(newVal && !this.ulBorderWidth) {
          this.$changeOptionsEV([1, newVal], ["ulBorderWidth", "showUlBorder"], false)
        } else {
          this.$changeOptionsEV(newVal, "showUlBorder", false)
        }
      }
    },
    ulBorderColor: {
      get() {
        return this.options.ulBorderColor || "transparent"
      },
      set(val) {
        this.$changeOptionsEV(val, "ulBorderColor", false)
      }
    },
    ulBorderWidth: {
      get() {
        return this.options.ulBorderWidth || 0
      },
      set(val) {
        this.$changeOptionsEV(val, "ulBorderWidth", false)
      }
    },
    ulBorderStyle: {
      get() {
        return this.options.ulBorderStyle || "solid"
      },
      set(val) {
        this.$changeOptionsEV(val, "ulBorderStyle", false)
      }
    },
    ulBorderIsThemeColor: {
      get() {
        return this.options.ulBorderIsThemeColor || false
      },
      set(val) {
        this.$changeOptionsEV(val, "ulBorderIsThemeColor", false)
      }
    },
    ulBorderTypeFlag: {
      get() {
        let defaultType = 1
        if (!this.options.hasOwnProperty("ulBorderTypeFlag")) {
          if (
            ((this.ulBorderTopLeftRadius === this.ulBorderTopRightRadius) === this.ulBorderBottomRightRadius) ===
            this.ulBorderBottomLeftRadius
          ) {
            defaultType = 2
          }
        }
        return this.options.ulBorderTypeFlag || defaultType
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "ulBorderTypeFlag", false)
      }
    },
    ulBorderRadius: {
      get() {
        return Number(this.options.ulBorderRadius) || 0
      },
      set(newVal) {
        this.$changeOptionsEV(
          [newVal, newVal, newVal, newVal, newVal],
          [
            "ulBorderRadius",
            "ulBorderTopLeftRadius",
            "ulBorderTopRightRadius",
            "ulBorderBottomRightRadius",
            "ulBorderBottomLeftRadius"
          ],
          false
        )
      }
    },
    ulBorderTopLeftRadius: {
      get() {
        return Number(this.options.ulBorderTopLeftRadius) || 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "ulBorderTopLeftRadius", false)
      }
    },
    ulBorderTopRightRadius: {
      get() {
        return Number(this.options.ulBorderTopRightRadius) || 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "ulBorderTopRightRadius", false)
      }
    },
    ulBorderBottomRightRadius: {
      get() {
        return Number(this.options.ulBorderBottomRightRadius) || 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "ulBorderBottomRightRadius", false)
      }
    },
    ulBorderBottomLeftRadius: {
      get() {
        return Number(this.options.ulBorderBottomLeftRadius) || 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "ulBorderBottomLeftRadius", false)
      }
    },
    ulBoxShadowColor: {
      get() {
        return this.options.ulBoxShadowColor || []
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "ulBoxShadowColor", false)
      }
    },
    ulBoxShadowH: {
      get() {
        return this.options.ulBoxShadowH || []
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "ulBoxShadowH", false)
      }
    },
    ulBoxShadowV: {
      get() {
        return this.options.ulBoxShadowV || []
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "ulBoxShadowV", false)
      }
    },
    ulBoxShadowBlur: {
      get() {
        return this.options.ulBoxShadowBlur || []
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "ulBoxShadowBlur", false)
      }
    },
    ulBoxShadowSpread: {
      get() {
        return this.options.ulBoxShadowSpread || []
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "ulBoxShadowSpread", false)
      }
    },
    showConnector:{
      get() {
        return this.checkAndSetPrimaryVal(this.options, "showConnector", "showConnector", false)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "showConnector", false)
      }
    },
    connectorColor:{
      get() {
        return this.checkAndSetPrimaryVal(this.options, "connectorColor", "connectorColor",
          {
            type: 'color',
            color: 'rgba(10, 107, 255, 1)',
            isThemeColor: true,
            data: {
              angle: 0,
              stops: [
                ['rgba(10, 107, 255, 1)', 0],
                ['rgba(10, 107, 255, 1)', 1]
              ]
            }
          }
        )
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "connectorColor", false)
      }
    },
    connectorWidth:{
      get() {
        return this.checkAndSetPrimaryVal(this.options, "connectorWidth", "connectorWidth", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "connectorWidth", false)
      }
    },
    // 边距
    ulPaddingTypeFlag: {
      get() {
        let defaultType = 1
        if (!this.options.hasOwnProperty("ulPaddingTypeFlag") || this.options.ulPaddingTypeFlag === undefined) {
          if (((this.ulPaddingTop === this.ulPaddingRight) === this.ulPaddingLeft) === this.ulPaddingBottom) {
            defaultType = 2
          }
        } else if (this.options.ulPaddingTypeFlag !== undefined) {
          defaultType = this.options.ulPaddingTypeFlag
        }
        return defaultType
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "ulPaddingTypeFlag", false)
      }
    },
    ulPadding: {
      get() {
        return this.options.ulPadding !== undefined ? this.options.ulPadding : 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "ulPadding", false)
      }
    },
    ulPaddingTop: {
      get() {
        return this.options.ulPaddingTop !== undefined ? this.options.ulPaddingTop : 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "ulPaddingTop", false)
      }
    },
    ulPaddingRight: {
      get() {
        return this.options.ulPaddingRight !== undefined ? this.options.ulPaddingRight : 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "ulPaddingRight", false)
      }
    },
    ulPaddingLeft: {
      get() {
        return this.options.ulPaddingLeft !== undefined ? this.options.ulPaddingLeft : 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "ulPaddingLeft", false)
      }
    },
    ulPaddingBottom: {
      get() {
        return this.options.ulPaddingBottom !== undefined ? this.options.ulPaddingBottom : 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "ulPaddingBottom", false)
      }
    },
    ulOpacity: {
      get() {
        return this.options.ulOpacity
      },
      set(val) {
        this.$changeOptionsEV(val, "ulOpacity", false)
      }
    },
    ulRotate: {
      get() {
        return this.options.ulRotate || 0
      },
      set(val) {
        this.$changeOptionsEV(val, "ulRotate", false)
      }
    },
    loginType() {
      return this.options.loginType
    },
    liShowMaxWidth: {
      get() {
        return this.options.liShowMaxWidth || false
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liShowMaxWidth", false)
      }
    },
    liShowMinWidth: {
      get() {
        return this.options.liShowMinWidth || false
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liShowMinWidth", false)
      }
    },
    liMaxWidthVal: {
      get() {
        return this.options.liMaxWidthVal || 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liMaxWidthVal", false)
      }
    },
    liMinWidthVal: {
      get() {
        return this.options.liMinWidthVal || 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liMinWidthVal", false)
      }
    },
    ulAlignmentType: {
      get() {
        return this.options.ulAlignmentType || "left"
      },
      set(val) {
        this.$changeOptionsEV(val, "ulAlignmentType", false)
      }
    },
    ulMarginTop: {
      get() {
        return this.options.ulMarginTop || 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "ulMarginTop", false)
      }
    },
    showDivide: {
      get() {
        return this.options.hasOwnProperty("showDivide") ? this.options.showDivide : false
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "showDivide", false)
      }
    },
    divideType: {
      get() {
        return this.options.hasOwnProperty("divideType") ? this.options.divideType : "line"
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "divideType", false)
      }
    },
    divideWidth: {
      get() {
        return this.options.hasOwnProperty("divideWidth") ? this.options.divideWidth : 1
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "divideWidth", false)
      }
    },
    divideHeight: {
      get() {
        return this.options.hasOwnProperty("divideHeight") ? this.options.divideHeight : 24
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "divideHeight", false)
      }
    },
    divideIconSrc: {
      get() {
        return this.options.hasOwnProperty("divideIconSrc") ? this.options.divideIconSrc : ""
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "divideIconSrc", false)
      }
    },
    divideIconType: {
      get() {
        return this.options.hasOwnProperty("divideIconType") ? this.options.divideIconType : "icon"
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "divideIconType", false)
      }
    },
    divideIconColorIsThemeColor: {
      get() {
        return this.options.hasOwnProperty("divideIconColorIsThemeColor") ? this.options.divideIconColorIsThemeColor : false
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "divideIconColorIsThemeColor", false)
      }
    },
    divideIconColor: {
      get() {
        return this.options.hasOwnProperty("divideIconColor") ? this.options.divideIconColor : "rgba(0,0,0,0.2)"
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "divideIconColor", false)
      }
    },
    divideResInfo: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "divideResInfo", "divideResInfo", {})
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "divideResInfo", false)
      }
    },
    showVerticalType:{
      get() {
        return this.options.showVerticalType|| false
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "showVerticalType", false)
      }
    },
    liActiveFontFamily: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "liActiveFontFamily", "liActiveFontFamily", "sans-serif")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liActiveFontFamily", false)
      }
    },
    liActiveFontSize: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "liActiveFontSize", "liActiveFontSize", 14)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liActiveFontSize", false)
      }
    },
    liActiveFontWeight: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "liActiveFontWeight", "liActiveFontWeight", "400")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liActiveFontWeight", false)
      }
    },
    liActiveFontStyle: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "liActiveFontStyle", "liActiveFontStyle", "normal")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liActiveFontStyle", false)
      }
    },
    liActiveTextDecoration: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "liActiveTextDecoration", "liActiveTextDecoration", "none")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liActiveTextDecoration", false)
      }
    },
    liActiveLineHeight: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "liActiveLineHeight", "liActiveLineHeight", 36)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liActiveLineHeight", false)
      }
    },
    liActiveLineHeightType: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "liActiveLineHeightType", "liActiveLineHeightType", "px")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liActiveLineHeightType", false)
      }
    },
    liActiveLetterSpacing: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "liActiveLetterSpacing", "liActiveLetterSpacing", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(`${newVal}`, "liActiveLetterSpacing", false)
      }
    },
    liActiveActiveArrangement() {
      return this.options.liActiveTextAlign
    },
    liActiveActiveArrangementOrder: {
      get() {
        return {
          _class: "icon-portal-text-down1",
          isActive: this.options.liWritingMode === "vertical-lr" ? true : false
        }
      },
      set(newVal) {
        let val = newVal ? "vertical-lr" : "horizontal-tb"
        this.$changeOptionsEV(val, "liActiveWritingMode", false)
      }
    },
    liActiveTextAlign: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "liActiveTextAlign", "liActiveTextAlign", "left")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liActiveTextAlign", false)
      }
    },
    liActiveWritingMode: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "liActiveWritingMode", "liActiveWritingMode", "horizontal-tb")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liActiveWritingMode", false)
      }
    },
    liActiveTextIsThemeColor: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "liActiveTextIsThemeColor", "liActiveTextIsThemeColor", true)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liActiveTextIsThemeColor", false)
      }
    },
    liActiveFontColor: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "liActiveFontColor", "liActiveFontColor", "#3D82F2")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liActiveFontColor", false)
      }
    },
    liActiveBgColor: {
      get() {
        let bgArr = []
        if (Array.isArray(this.options.liActiveBgColor)) {
          return this.options.liActiveBgColor
        } else if (this.options.liActiveBgColor) {
          bgArr = [
            {
              ...this.options.liActiveBgColor,
              isThemeColor: this.options.liActiveBgIsThemeColor
            }
          ]
        } else {
          bgArr = [
            {
              type: "color",
              label: "颜色",
              color: "rgba(255,255,255,1)",
              data: {
                stops: [
                  ["rgba(255,255,255,1)", 0],
                  ["rgba(255,255,255,1)", 1]
                ],
                angle: 0
              },
              isThemeColor: this.options.liActiveBgIsThemeColor
            }
          ]
        }
        this.$changeOptionsEV(bgArr, "liActiveBgColor", false, false, false, true)
        return this.options.liActiveBgColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liActiveBgColor", false)
      }
    },
    liActiveBgIsThemeColor: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "liActiveBgIsThemeColor", "liActiveBgIsThemeColor", false)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liActiveBgIsThemeColor", false)
      }
    },
    showLiActiveBorder: {
      get() {
        let showLiActiveBorder = false
        if (this.options.showLiActiveBorder === undefined) {
          if (this.options.liActiveBorderWidth) {
            showLiActiveBorder = true
          } else {
            showLiActiveBorder = false
          }
          this.$changeOptionsEV(showLiActiveBorder, "liActiveBgColor", false, false, false, true)
        } else {
          showLiActiveBorder = this.options.showLiActiveBorder
        }
        return showLiActiveBorder
      },
      set(newVal) {
        if(newVal && !this.liActiveBorderWidth) {
          this.$changeOptionsEV([1, newVal], ["liActiveBorderWidth", "showLiActiveBorder"], false)
        } else {
          this.$changeOptionsEV(newVal, "showLiActiveBorder", false)
        }
      }
    },
    liActiveBorderWidth: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "liActiveBorderWidth", "liActiveBorderWidth", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liActiveBorderWidth", false)
      }
    },
    liActiveBorderColor: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "liActiveBorderColor", "liActiveBorderColor", "#3D82F2")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liActiveBorderColor", false)
      }
    },
    liActiveBorderStyle: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "liActiveBorderStyle", "liActiveBorderStyle", "solid")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liActiveBorderStyle", false)
      }
    },
    liActiveBorderIsThemeColor: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "liActiveBorderIsThemeColor", "liActiveBorderIsThemeColor", false)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liActiveBorderIsThemeColor", false)
      }
    },
    liActiveBorderTypeFlag: {
      get() {
        let defaultType = 1
        if (!this.options.hasOwnProperty("liActiveBorderTypeFlag")) {
          if (
            ((this.liActiveBorderTopLeftRadius === this.liActiveBorderTopRightRadius) ===
              this.liActiveBorderBottomRightRadius) ===
            this.liActiveBorderBottomLeftRadius
          ) {
            defaultType = 2
          }
          this.$changeOptionsEV(defaultType, "liActiveBorderTypeFlag", false, false, false, true)
        }
        return this.options.liActiveBorderTypeFlag
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liActiveBorderTypeFlag", false)
      }
    },
    liActiveBorderRadius: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "liActiveBorderRadius", "liActiveBorderRadius", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(
          [newVal, newVal, newVal, newVal, newVal],
          [
            "liActiveBorderRadius",
            "liActiveBorderTopLeftRadius",
            "liActiveBorderTopRightRadius",
            "liActiveBorderBottomRightRadius",
            "liActiveBorderBottomLeftRadius"
          ],
          false
        )
      }
    },
    liActiveBorderTopLeftRadius: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "liActiveBorderTopLeftRadius", "liActiveBorderTopLeftRadius", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liActiveBorderTopLeftRadius", false)
      }
    },
    liActiveBorderTopRightRadius: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "liActiveBorderTopRightRadius", "liActiveBorderTopRightRadius", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liActiveBorderTopRightRadius", false)
      }
    },
    liActiveBorderBottomRightRadius: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "liActiveBorderBottomRightRadius", "liActiveBorderBottomRightRadius", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liActiveBorderBottomRightRadius", false)
      }
    },
    liActiveBorderBottomLeftRadius: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "liActiveBorderBottomLeftRadius", "liActiveBorderBottomLeftRadius", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liActiveBorderBottomLeftRadius", false)
      }
    },
    // 悬停时显示全部
    hoverShowAllContent:{
      get() {
        return this.options.hoverShowAllContent || false
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hoverShowAllContent", false)
      }
    },
  }
})
</script>

<style lang="scss" scoped>
.navBox {
  height: 32px;
  padding: 4px 4px 4px 12px;
  border-radius: 4px;
  background: var(--inputBg);
  display: flex;
  align-items: center;
  justify-content: space-between;
  &:hover {
    background: var(--inputNuberHoverThemeBgColor);
  }
  .navTitle {
    font-size: 13px;
    font-weight: 600;
    color: var(--textColor);
  }
  .navLabel{
    color: var(--thirdTextColor);
    display: flex;
  }
  .navIcon {
    font-size: 20px;
  }
  &:hover{
    // background-color: rgba(233, 233, 233, 1);
    cursor: pointer;
  }
}
.navBackBox {
  height: 38px;
  padding-left: 12px;
  display: flex;
  gap: 4px;
  align-items: center;
  &:hover {
    cursor: pointer;
  }
  .navBackIcon {
    font-size: 24px;
  }
  .navBackTitle {
    font-size: 14px;
    font-weight: 600;
    color: var(--textColor);
  }
}
::v-deep .submenu-container .el-collapse-item__content {
  padding: 0 !important;
}
::v-deep .sub-menu-setting .el-collapse-item__header {
  background: var(--elCollapseItemWrapBgColor) !important;
  font-weight: 400 !important;
}
::v-deep .sub-menu-setting .el-collapse-item__content {
  padding-top: 6px !important;
  padding-left: 25px !important;
  padding-right: 12px !important;
  padding-bottom: 12px !important;
}
.autoLayout-directions {
  background-color: var(--inputBackGround);
  border-radius: 3px;
  padding: 2px;
  color: var(--iconColor);
}

.autoLayout-directions span {
  display: inline-block;
  line-height: 28px;
  width: 60px;
  text-align: center;
  cursor: pointer;
  font-size: 16px;
}

.autoLayout-directions span.active {
  color: var(--themeColor);
  background-color: #FFFFFF;
  border-radius: 3px;
}
</style>
